var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuturaCyrillicBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20190801 at Wed Dec 29 15:11:38 2021\n By www-data\nCopyright (c) 1995 ParaGraph Intl., (c) 1998 ParaType Inc., ParaType Ltd. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FuturaCyrillicBook",
    horizAdvX: 500
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "FuturaCyrillicBook",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 5 2 2 2 4 2 3 3",
    ascent: 763,
    descent: -237,
    xHeight: 415,
    capHeight: 667,
    bbox: "-362 -250 1027 906",
    underlineThickness: 50,
    underlinePosition: -100,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017.var.accented",
    unicode: "\u0410`",
    horizAdvX: 622,
    d: "M532 0l-78 188h-284l-80 -188h-82l307 699l299 -699h-82zM199 258h226l-112 267zM393 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022.var.accented",
    unicode: "\u0415`",
    horizAdvX: 482,
    d: "M432 667v-70h-272v-198h264v-70h-264v-259h272v-70h-346v667h346zM323 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026.var.accented",
    unicode: "\u0418`",
    horizAdvX: 710,
    d: "M550 0v509l-464 -539v697h74v-511l464 539v-695h-74zM437 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032.var.accented",
    unicode: "\u041E`",
    horizAdvX: 794,
    d: "M397 -12q-146 0 -246.5 99t-100.5 246q0 148 101 246.5t246 98.5t246 -98.5t101 -246.5q0 -147 -100.5 -246t-246.5 -99zM397 608q-113 0 -192 -80t-79 -195t79 -195t192 -80t192 80t79 195t-79 195t-192 80zM479 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037.var.accented",
    unicode: "\u0423`",
    horizAdvX: 568,
    d: "M8 667h90l208 -393l174 393h80l-301 -667h-80l85 186zM366 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045.var.accented",
    unicode: "\u042B`",
    horizAdvX: 710,
    d: "M86 0v667h74v-277h90q230 0 230 -188q0 -94 -58.5 -148t-157.5 -54h-178zM160 320v-250h86q85 0 123 37q35 33 35 95q0 72 -54 101q-31 17 -112 17h-78zM550 667h74v-667h-74v667zM437 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047.var.accented",
    unicode: "\u042D`",
    horizAdvX: 645,
    d: "M50 520v92q96 66 217 66q149 0 238.5 -97.5t89.5 -249.5q0 -149 -88 -246t-236 -97q-120 0 -221 65v92q30 -31 77 -54q69 -33 144 -33q101 0 175 71t73 181h-389v70h386q-8 97 -75.5 162.5t-168.5 65.5q-71 0 -135 -28q-51 -24 -87 -60zM338 882l70 -45l-153 -117l-43 32 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048.var.accented",
    unicode: "\u042E`",
    horizAdvX: 990,
    d: "M160 389h102q18 125 111.5 207t225.5 82q148 0 244.5 -97t96.5 -248q0 -149 -97 -247t-244 -98q-145 0 -240 97t-100 234h-99v-319h-74v667h74v-278zM599 608q-111 0 -187.5 -79t-76.5 -196t76.5 -196t187.5 -79t188 79t77 196t-77 196t-188 79zM577 882l70 -45 l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049.var.accented",
    unicode: "\u042F`",
    horizAdvX: 510,
    d: "M30 0l196 296q-68 7 -112 42q-58 47 -58 136q0 82 46 133q54 60 166 60h156v-667h-74v292h-40l-190 -292h-90zM350 597h-72q-80 0 -114 -35q-32 -34 -32 -86q0 -59 38 -90q36 -28 102 -28h78v239zM337 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023.var.accented",
    unicode: "\u0401`",
    horizAdvX: 482,
    d: "M432 667v-70h-272v-198h264v-70h-264v-259h272v-70h-346v667h346zM291 882l55 -37l-124 -118l-34 25zM86 793q0 21 13.5 34.5t34.5 13.5q23 0 36 -15t13 -33q0 -20 -14.5 -34.5t-34.5 -14.5q-18 0 -33 13t-15 36zM335 793q0 18 13 33t36 15q21 0 34.5 -13.5t13.5 -34.5 q0 -23 -15 -36t-33 -13q-20 0 -34.5 14.5t-14.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065.var.accented",
    unicode: "\u0430`",
    horizAdvX: 526,
    d: "M386 356v59h72v-415h-72v58q-54 -70 -142 -70q-84 0 -143 58t-59 162q0 102 58.5 159.5t143.5 57.5q90 0 142 -69zM252 361q-57 0 -96.5 -40.5t-39.5 -112.5q0 -69 36.5 -112.5t99.5 -43.5t100.5 45t37.5 110q0 74 -42 114t-96 40zM325 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070.var.accented",
    unicode: "\u0435`",
    horizAdvX: 481,
    d: "M376 139l60 -33q-21 -40 -51 -67q-57 -51 -138 -51q-84 0 -144.5 54.5t-60.5 162.5q0 95 54.5 157.5t146.5 62.5q104 0 157 -76q42 -60 39 -156h-323q1 -63 39 -102t93 -39q49 0 85 30q28 24 43 57zM121 253h244q-9 49 -42.5 78.5t-79.5 29.5q-45 0 -79.5 -30.5 t-42.5 -77.5zM302 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074.var.accented",
    unicode: "\u0438`",
    horizAdvX: 492,
    d: "M68 415h72v-274l284 306v-447h-72v277l-284 -306v444zM308 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080.var.accented",
    unicode: "\u043E`",
    horizAdvX: 524,
    d: "M262 -12q-95 0 -157.5 62t-62.5 156q0 95 62.5 157t157.5 62t157.5 -62t62.5 -157q0 -94 -62.5 -156t-157.5 -62zM262 361q-61 0 -103.5 -41.5t-42.5 -113.5t43 -113t103 -41t103 41t43 113q0 73 -42.5 114t-103.5 41zM324 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085.var.accented",
    unicode: "\u0443`",
    horizAdvX: 460,
    d: "M67 -230l132 269l-191 376h82l147 -297l135 297h80l-305 -645h-80zM292 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093.var.accented",
    unicode: "\u044B`",
    horizAdvX: 562,
    d: "M68 0v415h72v-159h74q86 0 126 -41q32 -32 32 -87q0 -58 -37 -93t-122 -35h-145zM140 64h67q45 0 64 11q27 18 27 53q0 36 -26 52q-18 12 -64 12h-68v-128zM422 0v415h72v-415h-72zM343 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095.var.accented",
    unicode: "\u044D`",
    horizAdvX: 423,
    d: "M42 334v70q52 21 113 21q105 0 165.5 -61t60.5 -159q0 -95 -61.5 -156t-159.5 -61q-62 0 -118 23v70q55 -29 117 -29q58 0 100 35.5t48 92.5h-219v64h219q-12 55 -53 86t-96 31q-58 0 -116 -27zM223 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096.var.accented",
    unicode: "\u044E`",
    horizAdvX: 690,
    d: "M140 245h75q10 70 56 118q59 62 157 62q96 0 158 -62t62 -157q0 -94 -62.5 -156t-157.5 -62q-109 0 -171 78q-40 50 -46 113h-71v-179h-72v415h72v-170zM428 361q-60 0 -101.5 -41.5t-41.5 -113.5q0 -73 42 -113.5t101 -40.5q60 0 103 41t43 113t-42.5 113.5t-103.5 41.5 zM407 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097.var.accented",
    unicode: "\u044F`",
    horizAdvX: 408,
    d: "M20 0l129 171q-6 0 -16.5 2t-30.5 10t-33 21q-33 31 -33 83q0 59 37 93q37 35 122 35h145v-415h-72v167h-44l-118 -167h-86zM268 227v124h-67q-47 0 -65 -11q-26 -17 -26 -51t26 -50q19 -12 64 -12h68zM266 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071.var.accented",
    unicode: "\u0451`",
    horizAdvX: 481,
    d: "M376 139l60 -33q-21 -40 -51 -67q-56 -51 -138 -51q-90 0 -144 54q-61 60 -61 163q0 107 66 169q54 51 135 51q106 0 157 -76q42 -60 39 -156h-323q-1 -62 42 -105q36 -36 90 -36q51 0 85 30q28 24 43 57zM121 253h244q-7 41 -37 73q-35 35 -85 35t-85 -37 q-28 -28 -37 -71zM78 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM308 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM291 666l61 -27l-134 -135l-32 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 460,
    d: "M244 349h-102v-349h-72v349h-40v66h40v156q0 75 24 109q41 61 137 61q98 0 137 -61q24 -39 24 -109v-17h-72v17q0 43 -14 65q-21 32 -75 32t-75 -32q-14 -20 -14 -65v-156h102v-66zM320 415h72v-415h-72v415z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 460,
    d: "M244 349h-102v-349h-72v349h-40v66h40v156q0 75 24 109q41 61 137 61q98 0 137 -61q24 -39 24 -109v-571h-72v571q0 43 -14 65q-21 32 -75 32t-75 -32q-14 -20 -14 -65v-156h102v-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 280,
    d: "M176 135h-72v532h72v-532zM90 40q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 330,
    d: "M134 667l-13 -268h-54l-13 268h80zM276 667l-13 -268h-54l-13 268h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 600,
    d: "M394 0h-73l32 207h-136l-32 -207h-73l32 207h-110l10 66h110l20 133h-110l10 66h110l30 195h73l-30 -195h136l30 195h73l-30 -195h110l-10 -66h-110l-20 -133h110l-10 -66h-110zM363 273l20 133h-136l-20 -133h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 568,
    d: "M467 574l-59 -39q-15 31 -38 50q-19 17 -43 21v-222q79 -31 117 -70q47 -48 47 -121q0 -72 -44 -130.5t-120 -70.5v-93h-60v89q-75 3 -128 54q-46 46 -62 118l72 20q7 -52 40 -85q34 -35 78 -37v274q-72 29 -110 65q-46 43 -46 109q0 70 45 117t111 53v87h60v-87 q42 -4 76 -28q40 -28 64 -74zM327 304v-242q40 11 64 48t24 80q0 47 -32 79q-21 21 -56 35zM267 411v195q-39 -6 -60.5 -34t-21.5 -65q0 -35 25 -60q22 -22 57 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 710,
    d: "M178 673q61 0 103 -42t42 -103t-42 -103t-103 -42t-103 42t-42 103t42 103t103 42zM178 438q36 0 60.5 26.5t24.5 63.5t-24.5 63.5t-60.5 26.5q-35 0 -60 -26.5t-25 -63.5t25 -63.5t60 -26.5zM141 10l389 670l39 -22l-389 -671zM532 283q61 0 103 -42t42 -103t-42 -103 t-103 -42t-103 42t-42 103t42 103t103 42zM532 48q36 0 60.5 26.5t24.5 63.5t-24.5 63.5t-60.5 26.5q-35 0 -60 -26.5t-25 -63.5t25 -63.5t60 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 636,
    d: "M545 289l54 -45q-33 -45 -85 -99l112 -145h-92l-72 93q-46 -46 -103.5 -75.5t-111.5 -29.5q-82 0 -137.5 53t-55.5 132q0 78 60 138q31 31 112 83q-66 85 -66 143q0 57 38.5 99t106.5 42q66 0 103.5 -40t37.5 -94q0 -67 -62 -121q-7 -6 -18.5 -14.5t-35.5 -28.5l139 -179 q51 54 76 88zM417 148l-148 191q-53 -33 -94 -69q-47 -42 -47 -96q0 -50 33.5 -84t84.5 -34q75 0 171 92zM257 475l30 -41l44 34q45 36 45 77q0 33 -21.5 51t-50.5 18q-31 0 -52.5 -21t-21.5 -52q0 -29 27 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 188,
    d: "M134 667l-13 -268h-54l-13 268h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 294,
    d: "M167 740l63 -29q-33 -87 -51 -173q-25 -121 -25 -252q0 -130 24 -244q18 -88 52 -183l-63 -29q-46 121 -66 226q-21 111 -21 232q0 138 28 260q22 94 59 192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 294,
    d: "M64 711l63 29q37 -98 59 -192q28 -122 28 -260q0 -121 -21 -232q-20 -105 -66 -226l-63 29q34 95 52 183q24 114 24 244q0 131 -25 252q-18 86 -51 173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 568,
    d: "M139 648l116 -43l-5 124h68l-5 -124l116 43l21 -63l-120 -34l77 -97l-54 -39l-69 103l-69 -103l-54 39l77 97l-120 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M33 300v66h181v172h72v-172h181v-66h-181v-172h-72v172h-181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 274,
    d: "M24 -133l82 231l66 -24l-101 -226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 320,
    d: "M50 176v74h220v-74h-220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 228,
    d: "M64 40q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 592,
    d: "M0 -170l514 929l58 -30l-514 -927z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 568,
    d: "M284 -12q-102 0 -171 100q-67 97 -67 245t67 245q69 100 171 100t171 -100q67 -97 67 -245t-67 -245q-69 -100 -171 -100zM284 610q-69 0 -115 -74q-49 -78 -49 -203t49 -203q46 -74 115 -74t115 74q49 78 49 203t-49 203q-46 74 -115 74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 568,
    d: "M266 0v597h-112l39 70h147v-667h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 568,
    d: "M481 0h-431l243 281q62 73 78 97q37 53 37 102q0 57 -37 93.5t-96 36.5q-72 0 -111 -59q-21 -32 -22 -79h-74q4 85 50 138q60 68 158 68q89 0 147.5 -56.5t58.5 -142.5q0 -67 -53 -143q-27 -37 -91 -111l-139 -157h282v-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 568,
    d: "M160 502h-74q3 53 31 98q50 78 155 78q89 0 138.5 -53t49.5 -127q0 -105 -86 -148q13 -5 25.5 -13.5t30.5 -26.5t29 -49.5t11 -71.5q0 -91 -58.5 -146t-146.5 -55q-59 0 -110 27.5t-76 87.5q-13 32 -15 70h74q5 -41 24 -67q34 -50 103 -50q55 0 93 39.5t38 95.5 q0 82 -66 112q-33 16 -76 14v66q43 -3 76 14q56 29 56 99q0 49 -28 81.5t-86 32.5q-56 0 -86 -38q-23 -30 -26 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 568,
    d: "M436 704v-510h82v-68h-82v-126h-74v126h-342zM151 194h211v295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 568,
    d: "M479 667v-68h-214l-43 -144q17 4 42 4q99 0 159.5 -66t60.5 -165q0 -108 -70.5 -174t-172.5 -66q-86 0 -149 52q-36 31 -58 68l59 42q15 -30 45 -54q49 -40 108 -40q70 0 117 50t47 121q0 72 -46.5 118t-117.5 46q-63 0 -129 -46l97 322h265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 568,
    d: "M336 683l56 -42l-153 -213q29 9 59 9q95 0 155.5 -63t60.5 -157q0 -100 -64.5 -164.5t-164.5 -64.5q-74 0 -128.5 35.5t-78.5 86t-24 105.5q0 76 55 153zM284 56q68 0 112 45.5t44 113.5q0 67 -44.5 110.5t-112.5 43.5t-111.5 -44t-43.5 -110q0 -68 43.5 -113.5 t112.5 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 568,
    d: "M52 23l379 576h-365v68h490l-446 -683z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 568,
    d: "M387 347q101 -45 101 -163q0 -83 -53.5 -139.5t-150.5 -56.5t-150.5 56.5t-53.5 139.5q0 118 101 163q-81 47 -81 146q0 76 49 130.5t135 54.5t135 -54.5t49 -130.5q0 -99 -81 -146zM284 377q49 0 81.5 33t32.5 82q0 53 -33.5 85.5t-80.5 32.5t-80.5 -32.5t-33.5 -85.5 q0 -49 32.5 -82t81.5 -33zM284 56q58 0 94 36.5t36 93.5q0 56 -36.5 91.5t-93.5 35.5t-93.5 -35.5t-36.5 -91.5q0 -57 36 -93.5t94 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 568,
    d: "M232 -16l-56 41l153 213q-29 -9 -59 -9q-95 0 -155.5 63t-60.5 157q0 100 64.5 164.5t164.5 64.5q74 0 128.5 -35.5t78.5 -86t24 -105.5q0 -77 -55 -153zM284 610q-68 0 -112 -45.5t-44 -113.5q0 -67 44.5 -110.5t112.5 -43.5t111.5 44t43.5 110q0 68 -43.5 113.5 t-112.5 45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 228,
    d: "M64 375q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM64 38q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 274,
    d: "M78 375q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM24 -133l82 231l66 -24l-101 -226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    d: "M110 330l357 -162v-72l-434 203v62l434 203v-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M33 384v66h434v-66h-434zM33 230v66h434v-66h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    d: "M390 330l-357 162v72l434 -203v-62l-434 -203v72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 436,
    d: "M289 289h72q0 -70 -41 -113q-38 -40 -103 -40q-64 0 -104 40t-40 103q0 86 84 124q20 9 49.5 17.5t34.5 10.5q64 23 64 88q0 46 -26 70q-23 21 -61 21q-41 0 -63 -21q-26 -25 -26 -67q0 -22 6 -42h-74q-4 19 -4 44q0 68 38 108q42 46 122 46q75 0 118 -43q44 -44 44 -118 q0 -59 -34 -98q-28 -32 -77 -50q-8 -3 -22.5 -7.5t-26.5 -8.5t-23 -9q-49 -23 -49 -70q0 -32 20 -52q18 -18 49 -18t49 18q24 24 24 67zM168 38q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 733,
    d: "M480 427l13 64h52q-38 -161 -47 -249v-8q3 -46 37 -46q39 0 76 54t37 137q0 111 -77.5 180t-189.5 69q-124 0 -210.5 -86.5t-86.5 -211.5q0 -51 16 -100t50 -94t96 -73t144 -28q110 0 209 46l15 -46q-100 -48 -225 -48q-156 0 -256 96t-100 248q0 145 100.5 245 t246.5 100q131 0 223.5 -82.5t92.5 -213.5q0 -100 -50.5 -168t-112.5 -68q-31 0 -51 18.5t-22 48.5q-46 -71 -125 -71q-63 0 -101.5 46t-38.5 115q0 83 49.5 143t125.5 60q43 0 70.5 -21.5t39.5 -55.5zM346 194q51 0 83 47.5t32 111.5q0 49 -25 73t-61 24q-51 0 -86.5 -44.5 t-35.5 -102.5q0 -51 27.5 -80t65.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 622,
    d: "M532 0l-78 188h-284l-80 -188h-82l307 699l299 -699h-82zM199 258h226l-112 267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 530,
    d: "M86 667h120q100 0 153 -42q60 -46 60 -138q0 -86 -66 -131q64 -16 95.5 -64.5t31.5 -103.5q0 -45 -19.5 -83t-48.5 -61q-56 -44 -160 -44h-166v667zM160 597v-223h56q15 0 29 1.5t33.5 8t34 17.5t24.5 33t10 51q0 31 -12 53.5t-27 33.5t-36 17t-32 7t-22 1h-58zM160 308 v-238h85q81 0 117 28q44 32 44 92q0 67 -57 98q-36 20 -113 20h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 646,
    d: "M596 612v-92q-40 40 -87 62q-57 26 -115 26q-115 0 -191.5 -80.5t-76.5 -197.5q0 -126 83.5 -199t185.5 -73q64 0 124 31q42 21 77 56v-92q-91 -65 -201 -65q-148 0 -246.5 99t-98.5 244q0 149 99.5 248t249.5 99q110 0 197 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 632,
    d: "M86 0v667h136q154 0 246 -78q114 -95 114 -256q0 -156 -117 -256q-48 -41 -103 -59t-141 -18h-135zM160 597v-527h65q119 0 191 60q90 76 90 203q0 120 -77 192t-204 72h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 482,
    d: "M432 667v-70h-272v-198h264v-70h-264v-259h272v-70h-346v667h346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 434,
    d: "M390 667v-70h-230v-197h222v-70h-222v-330h-74v667h304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 758,
    d: "M430 265v70h278v-16q0 -124 -64 -211q-89 -120 -248 -120q-148 0 -247 99.5t-99 245.5t99.5 245.5t248.5 99.5q118 0 204 -66q44 -34 77 -79l-55 -50q-29 41 -63 69q-69 56 -162 56q-119 0 -196 -79t-77 -197q0 -86 42 -150.5t102.5 -94t126.5 -29.5t120.5 30.5 t83.5 81.5q25 43 27 95h-198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 662,
    d: "M160 667v-271h342v271h74v-667h-74v326h-342v-326h-74v667h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 246,
    d: "M86 667h74v-667h-74v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 306,
    d: "M146 667h74v-480q0 -36 -1.5 -57.5t-11 -50.5t-28.5 -49q-39 -42 -106 -42q-76 0 -119 49l41 58q34 -37 76 -37q31 0 50 19q25 25 25 108v482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 568,
    d: "M160 667v-286l284 286h100l-312 -311l322 -356h-102l-273 306l-19 -19v-287h-74v667h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 358,
    d: "M86 667h74v-597h184v-70h-258v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 863,
    d: "M139 0h-76l111 704l256 -563l261 564l104 -705h-76l-63 464l-227 -492l-224 492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 766,
    d: "M160 0h-74v695l520 -545v517h74v-697l-520 545v-515z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 794,
    d: "M397 -12q-146 0 -246.5 99t-100.5 246q0 148 101 246.5t246 98.5t246 -98.5t101 -246.5q0 -147 -100.5 -246t-246.5 -99zM397 608q-113 0 -192 -80t-79 -195t79 -195t192 -80t192 80t79 195t-79 195t-192 80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 456,
    d: "M86 667h121q114 0 168 -47q61 -52 61 -143q0 -78 -52.5 -132.5t-158.5 -54.5h-65v-290h-74v667zM160 597v-237h61q66 0 103.5 32t37.5 89q0 116 -147 116h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 794,
    d: "M652 -7l-54 56q-90 -61 -201 -61q-145 0 -246 99t-101 246q0 148 101 246.5t246 98.5t246 -98.5t101 -246.5q0 -140 -94 -239l98 -101h-96zM480 268l117 -120q71 77 71 185q0 114 -79.5 194.5t-191.5 80.5q-113 0 -192 -80t-79 -195t79 -195t192 -80q81 0 148 44 l-161 166h96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 502,
    d: "M86 667h107q108 0 162 -37q73 -49 73 -148q0 -77 -46.5 -128t-121.5 -56l212 -298h-90l-203 292h-19v-292h-74v667zM160 597v-239h47q69 0 108 32t39 90q0 68 -53 98q-34 19 -96 19h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 518,
    d: "M443 574l-59 -39q-16 31 -39 50q-30 23 -75 23q-50 0 -81 -28.5t-31 -74.5q0 -34 25 -58q20 -20 70 -42l64 -28q71 -31 103 -63q48 -48 48 -121q0 -91 -60 -148t-151 -57q-90 0 -145 54q-45 44 -62 118l72 20q7 -50 40 -85q37 -37 96 -37q64 0 99 38.5t35 93.5 q0 48 -33 78q-19 18 -80 46l-60 28q-61 28 -89 55q-46 44 -46 109q0 77 52.5 124.5t134.5 47.5q62 0 107 -30q41 -27 65 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 426,
    d: "M412 597h-162v-597h-74v597h-162v70h398v-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 646,
    d: "M160 667v-409q0 -38 1.5 -59t14 -51.5t37.5 -51.5q45 -38 110 -38t110 38q25 21 37.5 51.5t14 51.5t1.5 59v409h74v-429q0 -102 -42 -160q-31 -42 -81.5 -66t-113.5 -24t-113.5 24t-81.5 66q-42 58 -42 160v429h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 556,
    d: "M8 667h82l188 -509l188 509h82l-270 -707z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 958,
    d: "M8 667h82l176 -500l209 534l198 -534l195 500h82l-280 -702l-196 534l-210 -534z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 504,
    d: "M14 0l197 345l-179 322h84l138 -251l142 251h84l-183 -322l193 -345h-84l-153 274l-155 -274h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 530,
    d: "M227 0v287l-219 380h86l170 -298l172 298h86l-221 -380v-287h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 536,
    d: "M512 667l-364 -597h354v-70h-478l364 597h-317v70h441z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 290,
    d: "M248 663h-96v-767h96v-66h-168v899h168v-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 597,
    d: "M597 -170l-58 -28l-519 927l58 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 290,
    d: "M42 -104h96v767h-96v66h168v-899h-168v66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M250 612l-146 -247h-78l177 302h94l177 -302h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    d: "M0 -132v64h500v-64h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    d: "M249 497l-135 135l74 34l105 -145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 526,
    d: "M386 356v59h72v-415h-72v58q-54 -70 -142 -70q-84 0 -143 58t-59 162q0 102 58.5 159.5t143.5 57.5q90 0 142 -69zM252 361q-57 0 -96.5 -40.5t-39.5 -112.5q0 -69 36.5 -112.5t99.5 -43.5t100.5 45t37.5 110q0 74 -42 114t-96 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 526,
    d: "M140 58v-58h-72v729h72v-372q55 68 142 68q93 0 147.5 -65.5t54.5 -154.5q0 -90 -54 -153.5t-145 -63.5t-145 70zM275 52q61 0 98 44.5t37 108.5q0 72 -41 114t-95 42t-96 -42t-42 -113q0 -65 38.5 -109.5t100.5 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 438,
    d: "M393 385v-86q-49 62 -130 62q-61 0 -104 -41.5t-43 -113.5t43 -113t103 -41q80 0 134 65v-86q-59 -43 -132 -43q-97 0 -159.5 61.5t-62.5 155.5q0 95 63 157.5t159 62.5q72 0 129 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 526,
    d: "M386 356v373h72v-729h-72v58q-54 -70 -142 -70q-84 0 -143 58t-59 162q0 102 58.5 159.5t143.5 57.5q90 0 142 -69zM252 361q-57 0 -96.5 -40.5t-39.5 -112.5q0 -69 36.5 -112.5t99.5 -43.5t100.5 45t37.5 110q0 74 -42 114t-96 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 481,
    d: "M376 139l60 -33q-21 -40 -51 -67q-57 -51 -138 -51q-84 0 -144.5 54.5t-60.5 162.5q0 95 54.5 157.5t146.5 62.5q104 0 157 -76q42 -60 39 -156h-323q1 -63 39 -102t93 -39q49 0 85 30q28 24 43 57zM121 253h244q-9 49 -42.5 78.5t-79.5 29.5q-45 0 -79.5 -30.5 t-42.5 -77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 240,
    d: "M244 349h-102v-349h-72v349h-40v66h40v181q0 83 40 117q32 27 83 27q27 0 51 -9v-70q-22 9 -47 9q-33 0 -46 -22q-9 -15 -9 -60v-173h102v-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 526,
    d: "M386 356v59h72v-405q0 -109 -40 -163q-57 -77 -166 -77q-92 0 -148 56q-54 54 -54 134h71q0 -50 32 -86q36 -40 100 -40q75 0 110 58q23 37 23 106v60q-54 -70 -142 -70q-86 0 -142 56q-60 60 -60 164q0 101 60 161q58 56 142 56q89 0 142 -69zM252 361q-55 0 -94 -39 q-42 -43 -42 -114q0 -79 47 -122q37 -34 89 -34q56 0 91 35q47 45 47 120t-44 117q-37 37 -94 37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 470,
    d: "M68 0v729h72v-362q44 58 119 58q80 0 119 -57q24 -35 24 -111v-257h-72v255q0 51 -19 76q-23 30 -68 30q-46 0 -73 -32q-30 -35 -30 -112v-217h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 208,
    d: "M68 415h72v-415h-72v415zM53 572q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 208,
    d: "M68 415h72v-645h-72v645zM53 572q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 422,
    d: "M68 729h72v-468l152 154h94l-178 -178l210 -237h-94l-166 189l-18 -18v-171h-72v729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 208,
    d: "M68 729h72v-729h-72v729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 685,
    d: "M68 0v415h72v-44q37 54 103 54q75 0 113 -67q43 67 125 67q135 0 135 -162v-263h-72v252q0 30 -3.5 50.5t-21 39.5t-49.5 19q-92 0 -92 -130v-231h-72v246q0 115 -75 115q-91 0 -91 -135v-226h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 470,
    d: "M68 0v415h72v-48q44 58 119 58q80 0 119 -57q24 -35 24 -111v-257h-72v255q0 51 -19 76q-23 30 -68 30q-46 0 -73 -32q-30 -35 -30 -112v-217h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 524,
    d: "M262 -12q-95 0 -157.5 62t-62.5 156q0 95 62.5 157t157.5 62t157.5 -62t62.5 -157q0 -94 -62.5 -156t-157.5 -62zM262 361q-61 0 -103.5 -41.5t-42.5 -113.5t43 -113t103 -41t103 41t43 113q0 73 -42.5 114t-103.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 526,
    d: "M140 58v-288h-72v645h72v-58q55 68 142 68q93 0 147.5 -65.5t54.5 -154.5q0 -90 -54 -153.5t-145 -63.5t-145 70zM275 52q61 0 98 44.5t37 108.5q0 72 -41 114t-95 42t-96 -42t-42 -113q0 -65 38.5 -109.5t100.5 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 526,
    d: "M386 356v59h72v-645h-72v288q-54 -70 -142 -70q-84 0 -143 58t-59 162q0 102 58.5 159.5t143.5 57.5q90 0 142 -69zM252 361q-57 0 -96.5 -40.5t-39.5 -112.5q0 -69 36.5 -112.5t99.5 -43.5t100.5 45t37.5 110q0 74 -42 114t-96 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 296,
    d: "M68 0v415h72v-45q35 55 94 55q30 0 64 -17l-34 -65q-20 14 -42 14q-38 0 -58 -26q-24 -32 -24 -112v-219h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 352,
    d: "M298 350l-59 -31q-17 42 -58 42q-21 0 -35.5 -12t-14.5 -35q0 -21 13.5 -31.5t53.5 -27.5q79 -33 104 -64q22 -27 22 -67q0 -63 -40.5 -99.5t-102.5 -36.5q-12 0 -26 2.5t-38.5 11t-46.5 32.5t-34 60l62 26q25 -68 84 -68q33 0 50.5 20t17.5 46q0 14 -4.5 24.5t-15 18.5 t-20 13t-27.5 13q-80 35 -101 61q-19 24 -19 61q0 54 33.5 85t87.5 31q79 0 114 -75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 214,
    d: "M214 349h-72v-349h-72v349h-44v66h44v150h72v-150h72v-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 466,
    d: "M140 415v-242q0 -63 20 -89q25 -32 73 -32t73 32q20 26 20 89v242h72v-250q0 -84 -38 -125q-49 -52 -127 -52t-127 52q-38 41 -38 125v250h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 424,
    d: "M8 415h80l124 -280l124 280h80l-204 -442z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 682,
    d: "M8 415h80l123 -282l130 314l129 -314l124 282h80l-206 -444l-128 310l-128 -310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 454,
    d: "M8 0l177 222l-151 193h88l107 -141l109 141h88l-152 -194l172 -221h-88l-131 169l-131 -169h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 460,
    d: "M67 -230l132 269l-191 376h82l147 -297l135 297h80l-305 -645h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 460,
    d: "M452 415l-300 -349h288v-66h-432l300 349h-242v66h386z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 501,
    d: "M275 581v-188q0 -48 -13 -71q-16 -27 -48 -42q32 -15 48 -42q13 -23 13 -71v-189q0 -51 19 -69t62 -18h15v-61h-27q-63 0 -93 20q-48 32 -48 116v196q0 39 -13 61q-16 26 -44 28v58q28 2 44 28q13 22 13 61v195q0 84 48 116q30 20 93 20h27v-61h-15q-43 0 -62 -18 t-19 -69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    d: "M214 -250v1000h72v-1000h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 501,
    d: "M226 393v188q0 51 -19 69t-62 18h-15v61h27q63 0 93 -20q48 -32 48 -116v-195q0 -39 13 -61q16 -26 44 -28v-58q-28 -2 -44 -28q-13 -22 -13 -61v-196q0 -84 -48 -116q-30 -20 -93 -20h-27v61h15q43 0 62 18t19 69v189q0 48 13 71q16 27 48 42q-32 15 -48 42 q-13 23 -13 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M446 361l44 -26q-19 -44 -50 -73q-39 -39 -96 -39q-34 0 -108 34q-69 32 -95 32q-29 0 -52 -20q-19 -16 -35 -52l-44 26q23 49 48 78q34 38 87 38q42 0 113 -34q69 -32 95 -32q37 0 61 24q19 17 32 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023",
    unicode: "\u0401",
    horizAdvX: 482,
    d: "M432 667v-70h-272v-198h264v-70h-264v-259h272v-70h-346v667h346zM112 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM302 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10051",
    unicode: "\u0402",
    horizAdvX: 646,
    d: "M450 597h-202v-212q71 23 137 23q120 0 175 -67q44 -54 44 -147q0 -112 -70 -163q-49 -37 -134 -37q-28 0 -68 6v70q28 -6 63 -6q61 0 93 27q40 34 40 104q0 63 -28 97q-39 46 -122 46q-64 0 -130 -23v-315h-74v597h-160v70h436v-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10052",
    unicode: "\u0403",
    horizAdvX: 404,
    d: "M86 0v667h304v-70h-230v-597h-74zM322 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10053",
    unicode: "\u0404",
    horizAdvX: 645,
    d: "M595 612v-92q-36 36 -87 60q-64 28 -135 28q-101 0 -168.5 -65.5t-75.5 -162.5h386v-70h-389q-1 -110 73 -181t175 -71q75 0 144 33q47 23 77 54v-92q-101 -65 -221 -65q-148 0 -236 97t-88 246q0 152 89.5 249.5t238.5 97.5q121 0 217 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10054",
    unicode: "\u0405",
    horizAdvX: 518,
    d: "M443 574l-59 -39q-16 31 -39 50q-30 23 -75 23q-50 0 -81 -28.5t-31 -74.5q0 -34 25 -58q20 -20 70 -42l64 -28q71 -31 103 -63q48 -48 48 -121q0 -91 -60 -148t-151 -57q-90 0 -145 54q-45 44 -62 118l72 20q7 -50 40 -85q37 -37 96 -37q64 0 99 38.5t35 93.5 q0 48 -33 78q-19 18 -80 46l-60 28q-61 28 -89 55q-46 44 -46 109q0 77 52.5 124.5t134.5 47.5q62 0 107 -30q41 -27 65 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10055",
    unicode: "\u0406",
    horizAdvX: 246,
    d: "M86 667h74v-667h-74v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10056",
    unicode: "\u0407",
    horizAdvX: 246,
    d: "M86 667h74v-667h-74v667zM15 784q0 21 13 36t32 15t32 -15t13 -36t-13 -36t-32 -15t-32 15t-13 36zM141 784q0 21 13 36t32 15t32 -15t13 -36t-13 -36t-32 -15t-32 15t-13 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10057",
    unicode: "\u0408",
    horizAdvX: 306,
    d: "M146 667h74v-480q0 -36 -1.5 -57.5t-11 -50.5t-28.5 -49q-39 -42 -106 -42q-76 0 -119 49l41 58q34 -37 76 -37q31 0 50 19q25 25 25 108v482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10058",
    unicode: "\u0409",
    horizAdvX: 922,
    d: "M154 667h406v-277h90q230 0 230 -188q0 -94 -58.5 -148t-157.5 -54h-178v597h-258v-358q0 -47 -1 -70.5t-15.5 -66t-43.5 -68.5q-45 -40 -114 -40q-16 0 -40 6v70q20 -6 37 -6q39 0 65 26q18 18 27 51.5t10 56.5t1 71v398zM560 320v-250h86q85 0 123 37q35 33 35 95 q0 72 -54 101q-31 17 -112 17h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10059",
    unicode: "\u040A",
    horizAdvX: 938,
    d: "M160 667v-277h342v277h74v-277h90q230 0 230 -188q0 -94 -58.5 -148t-157.5 -54h-178v320h-342v-320h-74v667h74zM576 320v-250h86q85 0 123 37q35 33 35 95q0 72 -54 101q-31 17 -112 17h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10060",
    unicode: "\u040B",
    horizAdvX: 678,
    d: "M450 597h-202v-196q93 7 138 7q119 0 165 -36q61 -47 61 -155v-217h-74v207q0 81 -40 110q-28 21 -116 21q-59 0 -134 -7v-331h-74v597h-160v70h436v-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10061",
    unicode: "\u040C",
    horizAdvX: 568,
    d: "M160 667v-286l284 286h100l-312 -311l322 -356h-102l-273 306l-19 -19v-287h-74v667h74zM366 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10062",
    unicode: "\u040E",
    horizAdvX: 568,
    d: "M8 667h90l208 -393l174 393h80l-301 -667h-80l85 186zM135 818l70 23q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l70 -23q-4 -11 -11.5 -23t-24.5 -31t-48 -31t-71 -12t-71 12t-48 31t-24.5 31t-11.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10145",
    unicode: "\u040F",
    horizAdvX: 658,
    d: "M86 0v667h74v-597h338v597h74v-667h-208v-160h-70v160h-208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017",
    unicode: "\u0410",
    horizAdvX: 622,
    d: "M532 0l-78 188h-284l-80 -188h-82l307 699l299 -699h-82zM199 258h226l-112 267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10018",
    unicode: "\u0411",
    horizAdvX: 530,
    d: "M86 0v667h331v-70h-257v-207h90q230 0 230 -188q0 -94 -58.5 -148t-157.5 -54h-178zM160 320v-250h86q85 0 123 37q35 33 35 95q0 72 -54 101q-31 17 -112 17h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10019",
    unicode: "\u0412",
    horizAdvX: 530,
    d: "M86 667h120q100 0 153 -42q60 -46 60 -138q0 -86 -66 -131q64 -16 95.5 -64.5t31.5 -103.5q0 -45 -19.5 -83t-48.5 -61q-56 -44 -160 -44h-166v667zM160 597v-223h56q15 0 29 1.5t33.5 8t34 17.5t24.5 33t10 51q0 31 -12 53.5t-27 33.5t-36 17t-32 7t-22 1h-58zM160 308 v-238h85q81 0 117 28q44 32 44 92q0 67 -57 98q-36 20 -113 20h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10020",
    unicode: "\u0413",
    horizAdvX: 404,
    d: "M86 0v667h304v-70h-230v-597h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10021",
    unicode: "\u0414",
    horizAdvX: 640,
    d: "M144 667h406v-597h76v-210h-70v140h-472v-140h-70v210q34 -1 62 24.5t44 65.5q24 61 24 175v332zM218 597v-262q0 -123 -24 -186q-17 -45 -51 -79h333v527h-258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022",
    unicode: "\u0415",
    horizAdvX: 482,
    d: "M432 667v-70h-272v-198h264v-70h-264v-259h272v-70h-346v667h346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10024",
    unicode: "\u0416",
    horizAdvX: 810,
    d: "M368 667h74v-286l254 286h92l-280 -311l288 -356h-94l-244 305l-16 -18v-287h-74v287l-16 18l-244 -305h-94l288 356l-280 311h92l254 -286v286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10025",
    unicode: "\u0417",
    horizAdvX: 576,
    d: "M157 536l-57 45q65 97 191 97q90 0 141 -47q52 -47 52 -123q0 -49 -25.5 -85.5t-66.5 -55.5q65 -15 99.5 -62t34.5 -110q0 -104 -83 -163q-64 -44 -152 -44q-91 0 -151 46t-90 114l72 32q20 -56 66 -89t106 -33q61 0 102 28q54 38 54 107q0 131 -178 131h-60v70h60 q66 0 101 32t35 81q0 43 -27 70q-30 31 -90 31q-84 0 -134 -72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026",
    unicode: "\u0418",
    horizAdvX: 710,
    d: "M550 0v509l-464 -539v697h74v-511l464 539v-695h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10027",
    unicode: "\u0419",
    horizAdvX: 710,
    d: "M550 0v509l-464 -539v697h74v-511l464 539v-695h-74zM200 818l70 23q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l70 -23q-4 -11 -11.5 -23t-24.5 -31t-48 -31t-71 -12t-71 12t-48 31t-24.5 31t-11.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10028",
    unicode: "\u041A",
    horizAdvX: 568,
    d: "M160 667v-286l284 286h100l-312 -311l322 -356h-102l-273 306l-19 -19v-287h-74v667h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10029",
    unicode: "\u041B",
    horizAdvX: 646,
    d: "M154 667h406v-667h-74v597h-258v-358q0 -47 -1 -70.5t-15.5 -66t-43.5 -68.5q-45 -40 -114 -40q-16 0 -40 6v70q20 -6 37 -6q39 0 65 26q18 18 27 51.5t10 56.5t1 71v398z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10030",
    unicode: "\u041C",
    horizAdvX: 863,
    d: "M139 0h-76l111 704l256 -563l261 564l104 -705h-76l-63 464l-227 -492l-224 492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10031",
    unicode: "\u041D",
    horizAdvX: 662,
    d: "M160 667v-271h342v271h74v-667h-74v326h-342v-326h-74v667h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032",
    unicode: "\u041E",
    horizAdvX: 794,
    d: "M397 -12q-146 0 -246.5 99t-100.5 246q0 148 101 246.5t246 98.5t246 -98.5t101 -246.5q0 -147 -100.5 -246t-246.5 -99zM397 608q-113 0 -192 -80t-79 -195t79 -195t192 -80t192 80t79 195t-79 195t-192 80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10033",
    unicode: "\u041F",
    horizAdvX: 662,
    d: "M86 667h490v-667h-74v597h-342v-597h-74v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10034",
    unicode: "\u0420",
    horizAdvX: 456,
    d: "M86 667h121q114 0 168 -47q61 -52 61 -143q0 -78 -52.5 -132.5t-158.5 -54.5h-65v-290h-74v667zM160 597v-237h61q66 0 103.5 32t37.5 89q0 116 -147 116h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10035",
    unicode: "\u0421",
    horizAdvX: 646,
    d: "M596 612v-92q-40 40 -87 62q-57 26 -115 26q-115 0 -191.5 -80.5t-76.5 -197.5q0 -126 83.5 -199t185.5 -73q64 0 124 31q42 21 77 56v-92q-91 -65 -201 -65q-148 0 -246.5 99t-98.5 244q0 149 99.5 248t249.5 99q110 0 197 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10036",
    unicode: "\u0422",
    horizAdvX: 426,
    d: "M412 597h-162v-597h-74v597h-162v70h398v-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037",
    unicode: "\u0423",
    horizAdvX: 568,
    d: "M8 667h90l208 -393l174 393h80l-301 -667h-80l85 186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10038",
    unicode: "\u0424",
    horizAdvX: 822,
    d: "M374 0v94h-18q-71 0 -126.5 17t-88.5 43t-54.5 62t-29 69.5t-7.5 68.5t7.5 68.5t29 69.5t54.5 62t88.5 43t126.5 17h18v80h74v-80h18q71 0 126.5 -17t88.5 -43t54.5 -62t29 -69.5t7.5 -68.5t-7.5 -68.5t-29 -69.5t-54.5 -62t-88.5 -43t-126.5 -17h-18v-94h-74zM374 164 v380h-20q-65 0 -112 -17t-71 -46.5t-34.5 -60.5t-10.5 -66t10.5 -66t34.5 -60.5t71 -46.5t112 -17h20zM448 544v-380h20q65 0 112 17t71 46.5t34.5 60.5t10.5 66t-10.5 66t-34.5 60.5t-71 46.5t-112 17h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10039",
    unicode: "\u0425",
    horizAdvX: 504,
    d: "M14 0l197 345l-179 322h84l138 -251l142 251h84l-183 -322l193 -345h-84l-153 274l-155 -274h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10040",
    unicode: "\u0426",
    horizAdvX: 662,
    d: "M86 0v667h74v-597h338v597h74v-597h76v-210h-70v140h-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10041",
    unicode: "\u0427",
    horizAdvX: 590,
    d: "M430 0v286q-93 -7 -138 -7q-119 0 -165 36q-61 47 -61 155v197h74v-187q0 -81 40 -110q28 -21 116 -21q59 0 134 7v311h74v-667h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10042",
    unicode: "\u0428",
    horizAdvX: 922,
    d: "M86 0v667h74v-597h264v597h74v-597h264v597h74v-667h-750z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10043",
    unicode: "\u0429",
    horizAdvX: 926,
    d: "M86 0v667h74v-597h264v597h74v-597h264v597h74v-597h76v-210h-70v140h-756z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10044",
    unicode: "\u042A",
    horizAdvX: 610,
    d: "M174 0v597h-160v70h234v-277h90q230 0 230 -188q0 -94 -58.5 -148t-157.5 -54h-178zM248 320v-250h86q85 0 123 37q35 33 35 95q0 72 -54 101q-31 17 -112 17h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045",
    unicode: "\u042B",
    horizAdvX: 710,
    d: "M86 0v667h74v-277h90q230 0 230 -188q0 -94 -58.5 -148t-157.5 -54h-178zM160 320v-250h86q85 0 123 37q35 33 35 95q0 72 -54 101q-31 17 -112 17h-78zM550 667h74v-667h-74v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10046",
    unicode: "\u042C",
    horizAdvX: 522,
    d: "M86 0v667h74v-277h90q230 0 230 -188q0 -94 -58.5 -148t-157.5 -54h-178zM160 320v-250h86q85 0 123 37q35 33 35 95q0 72 -54 101q-31 17 -112 17h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047",
    unicode: "\u042D",
    horizAdvX: 645,
    d: "M50 520v92q96 66 217 66q149 0 238.5 -97.5t89.5 -249.5q0 -149 -88 -246t-236 -97q-120 0 -221 65v92q30 -31 77 -54q69 -33 144 -33q101 0 175 71t73 181h-389v70h386q-8 97 -75.5 162.5t-168.5 65.5q-71 0 -135 -28q-51 -24 -87 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048",
    unicode: "\u042E",
    horizAdvX: 990,
    d: "M160 389h102q18 125 111.5 207t225.5 82q148 0 244.5 -97t96.5 -248q0 -149 -97 -247t-244 -98q-145 0 -240 97t-100 234h-99v-319h-74v667h74v-278zM599 608q-111 0 -187.5 -79t-76.5 -196t76.5 -196t187.5 -79t188 79t77 196t-77 196t-188 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049",
    unicode: "\u042F",
    horizAdvX: 510,
    d: "M30 0l196 296q-68 7 -112 42q-58 47 -58 136q0 82 46 133q54 60 166 60h156v-667h-74v292h-40l-190 -292h-90zM350 597h-72q-80 0 -114 -35q-32 -34 -32 -86q0 -59 38 -90q36 -28 102 -28h78v239z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065",
    unicode: "\u0430",
    horizAdvX: 526,
    d: "M386 356v59h72v-415h-72v58q-54 -70 -142 -70q-84 0 -143 58t-59 162q0 102 58.5 159.5t143.5 57.5q90 0 142 -69zM252 361q-57 0 -96.5 -40.5t-39.5 -112.5q0 -69 36.5 -112.5t99.5 -43.5t100.5 45t37.5 110q0 74 -42 114t-96 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10066",
    unicode: "\u0431",
    horizAdvX: 524,
    d: "M388 700h80q-11 -37 -37.5 -62.5t-48 -34.5t-50.5 -16q-5 -1 -24 -5.5t-29 -7.5t-26 -8t-29 -12t-24 -15q-38 -29 -61.5 -80.5t-25.5 -109.5h2q45 76 151 76q93 0 154.5 -63t61.5 -156q0 -94 -63 -156t-164 -62q-87 0 -143 52q-70 64 -70 214q0 261 118 342q9 6 19 11.5 t21.5 10t19.5 8t22.5 7t20 5t22 5t20.5 4.5q40 9 58 21.5t25 31.5zM262 361q-61 0 -103.5 -41.5t-42.5 -113.5t43 -113t103 -41t103 41t43 113q0 73 -42.5 114t-103.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10067",
    unicode: "\u0432",
    horizAdvX: 430,
    d: "M68 415h157q57 0 87 -24q36 -29 36 -78q0 -54 -45 -83q31 -8 52 -28q33 -32 33 -80q0 -60 -43 -94q-37 -28 -98 -28h-179v415zM140 246h76q29 0 46 12q20 15 20 43q0 25 -20 40q-15 10 -58 10h-64v-105zM140 64h89q46 0 65 14q24 18 24 46q0 30 -21 47q-19 15 -65 15h-92 v-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10068",
    unicode: "\u0433",
    horizAdvX: 318,
    d: "M68 0v415h246v-66h-174v-349h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10069",
    unicode: "\u0434",
    horizAdvX: 460,
    d: "M98 415h292v-349h62v-176h-66v110h-316v-110h-66v176q52 1 77 54q17 35 17 110v185zM318 66v283h-148v-156q0 -83 -50 -127h198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070",
    unicode: "\u0435",
    horizAdvX: 481,
    d: "M376 139l60 -33q-21 -40 -51 -67q-57 -51 -138 -51q-84 0 -144.5 54.5t-60.5 162.5q0 95 54.5 157.5t146.5 62.5q104 0 157 -76q42 -60 39 -156h-323q1 -63 39 -102t93 -39q49 0 85 30q28 24 43 57zM121 253h244q-9 49 -42.5 78.5t-79.5 29.5q-45 0 -79.5 -30.5 t-42.5 -77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10072",
    unicode: "\u0436",
    horizAdvX: 596,
    d: "M262 415h72v-170l156 170h84l-180 -192l198 -223h-90l-154 175l-14 -14v-161h-72v161l-14 14l-154 -175h-90l198 223l-180 192h84l156 -170v170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10073",
    unicode: "\u0437",
    horizAdvX: 422,
    d: "M122 309l-50 41q24 35 53 52q39 23 91 23q63 0 98 -29q36 -31 36 -79q0 -58 -47 -87q30 -7 48 -27q29 -31 29 -76q0 -67 -54 -107q-44 -32 -118 -32q-66 0 -111 35q-34 25 -55 71l62 26q11 -28 37 -47q28 -21 68 -21q47 0 70 16q29 19 29 58q0 32 -25 48q-21 14 -68 14 h-42v66h35q38 0 54 11q22 14 22 38q0 28 -18 43q-17 15 -53 15q-31 0 -57 -16q-22 -14 -34 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074",
    unicode: "\u0438",
    horizAdvX: 492,
    d: "M68 415h72v-274l284 306v-447h-72v277l-284 -306v444z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10075",
    unicode: "\u0439",
    horizAdvX: 492,
    d: "M68 415h72v-274l284 306v-447h-72v277l-284 -306v444zM104 594l60 23q18 -60 85 -60t85 60l60 -23q-16 -45 -54.5 -71t-90.5 -26t-90.5 26t-54.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10076",
    unicode: "\u043A",
    horizAdvX: 422,
    d: "M68 415h72v-170l168 170h88l-180 -185l202 -230h-94l-162 182l-22 -21v-161h-72v415z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10077",
    unicode: "\u043B",
    horizAdvX: 450,
    d: "M382 415v-415h-72v349h-148v-187q0 -81 -32 -120q-36 -44 -100 -44q-8 0 -22 2v66q10 -2 16 -2q35 0 52 27q14 22 14 71v253h292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10078",
    unicode: "\u043C",
    horizAdvX: 580,
    d: "M20 0l100 447l172 -338l168 338l100 -447h-74l-55 257l-141 -286l-143 286l-53 -257h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10079",
    unicode: "\u043D",
    horizAdvX: 476,
    d: "M68 0v415h72v-170h196v170h72v-415h-72v179h-196v-179h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080",
    unicode: "\u043E",
    horizAdvX: 524,
    d: "M262 -12q-95 0 -157.5 62t-62.5 156q0 95 62.5 157t157.5 62t157.5 -62t62.5 -157q0 -94 -62.5 -156t-157.5 -62zM262 361q-61 0 -103.5 -41.5t-42.5 -113.5t43 -113t103 -41t103 41t43 113q0 73 -42.5 114t-103.5 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10081",
    unicode: "\u043F",
    horizAdvX: 470,
    d: "M68 415h334v-415h-72v349h-190v-349h-72v415z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10082",
    unicode: "\u0440",
    horizAdvX: 526,
    d: "M140 58v-288h-72v645h72v-58q55 68 142 68q93 0 147.5 -65.5t54.5 -154.5q0 -90 -54 -153.5t-145 -63.5t-145 70zM275 52q61 0 98 44.5t37 108.5q0 72 -41 114t-95 42t-96 -42t-42 -113q0 -65 38.5 -109.5t100.5 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10083",
    unicode: "\u0441",
    horizAdvX: 438,
    d: "M393 385v-86q-49 62 -130 62q-61 0 -104 -41.5t-43 -113.5t43 -113t103 -41q80 0 134 65v-86q-59 -43 -132 -43q-97 0 -159.5 61.5t-62.5 155.5q0 95 63 157.5t159 62.5q72 0 129 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10084",
    unicode: "\u0442",
    horizAdvX: 348,
    d: "M340 349h-130v-349h-72v349h-130v66h332v-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085",
    unicode: "\u0443",
    horizAdvX: 460,
    d: "M67 -230l132 269l-191 376h82l147 -297l135 297h80l-305 -645h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10086",
    unicode: "\u0444",
    horizAdvX: 650,
    d: "M289 -230v223q-109 0 -175 54q-72 59 -72 161t71 160q64 54 176 54v245h72v-245q112 0 176 -54q71 -58 71 -160t-72 -161q-66 -54 -175 -54v-223h-72zM289 57v301q-71 0 -111 -26q-62 -39 -62 -124q0 -80 58 -121q42 -30 115 -30zM361 358v-301q73 0 115 30q58 41 58 121 q0 85 -62 124q-40 26 -111 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10087",
    unicode: "\u0445",
    horizAdvX: 454,
    d: "M8 0l177 222l-151 193h88l107 -141l109 141h88l-152 -194l172 -221h-88l-131 169l-131 -169h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10088",
    unicode: "\u0446",
    horizAdvX: 474,
    d: "M68 0v415h72v-349h186v349h72v-349h68v-176h-66v110h-332z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10089",
    unicode: "\u0447",
    horizAdvX: 430,
    d: "M290 0v163q-58 -9 -98 -9q-68 0 -101 30q-35 31 -35 102v129h72v-119q0 -34 9 -49q14 -27 63 -27q44 0 90 9v186h72v-415h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10090",
    unicode: "\u0448",
    horizAdvX: 672,
    d: "M68 0v415h72v-349h160v349h72v-349h160v349h72v-415h-536z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10091",
    unicode: "\u0449",
    horizAdvX: 680,
    d: "M68 0v415h72v-349h160v349h72v-349h160v349h72v-349h68v-176h-66v110h-538z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10092",
    unicode: "\u044A",
    horizAdvX: 430,
    d: "M98 0v349h-90v66h162v-159h74q86 0 126 -41q32 -32 32 -87q0 -58 -37 -93t-122 -35h-145zM170 64h67q45 0 64 11q27 18 27 53q0 36 -26 52q-18 12 -64 12h-68v-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093",
    unicode: "\u044B",
    horizAdvX: 562,
    d: "M68 0v415h72v-159h74q86 0 126 -41q32 -32 32 -87q0 -58 -37 -93t-122 -35h-145zM140 64h67q45 0 64 11q27 18 27 53q0 36 -26 52q-18 12 -64 12h-68v-128zM422 0v415h72v-415h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10094",
    unicode: "\u044C",
    horizAdvX: 400,
    d: "M68 0v415h72v-159h74q86 0 126 -41q32 -32 32 -87q0 -58 -37 -93t-122 -35h-145zM140 64h67q45 0 64 11q27 18 27 53q0 36 -26 52q-18 12 -64 12h-68v-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095",
    unicode: "\u044D",
    horizAdvX: 423,
    d: "M42 334v70q52 21 113 21q105 0 165.5 -61t60.5 -159q0 -95 -61.5 -156t-159.5 -61q-62 0 -118 23v70q55 -29 117 -29q58 0 100 35.5t48 92.5h-219v64h219q-12 55 -53 86t-96 31q-58 0 -116 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096",
    unicode: "\u044E",
    horizAdvX: 690,
    d: "M140 245h75q10 70 56 118q59 62 157 62q96 0 158 -62t62 -157q0 -94 -62.5 -156t-157.5 -62q-109 0 -171 78q-40 50 -46 113h-71v-179h-72v415h72v-170zM428 361q-60 0 -101.5 -41.5t-41.5 -113.5q0 -73 42 -113.5t101 -40.5q60 0 103 41t43 113t-42.5 113.5t-103.5 41.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097",
    unicode: "\u044F",
    horizAdvX: 408,
    d: "M20 0l129 171q-6 0 -16.5 2t-30.5 10t-33 21q-33 31 -33 83q0 59 37 93q37 35 122 35h145v-415h-72v167h-44l-118 -167h-86zM268 227v124h-67q-47 0 -65 -11q-26 -17 -26 -51t26 -50q19 -12 64 -12h68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071",
    unicode: "\u0451",
    horizAdvX: 481,
    d: "M376 139l60 -33q-21 -40 -51 -67q-57 -51 -138 -51q-84 0 -144.5 54.5t-60.5 162.5q0 95 54.5 157.5t146.5 62.5q104 0 157 -76q42 -60 39 -156h-323q1 -63 39 -102t93 -39q49 0 85 30q28 24 43 57zM121 253h244q-9 49 -42.5 78.5t-79.5 29.5q-45 0 -79.5 -30.5 t-42.5 -77.5zM110 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM284 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10099",
    unicode: "\u0452",
    horizAdvX: 470,
    d: "M68 0v514h-68v60h68v155h72v-155h200v-60h-200v-187q44 58 119 58q80 0 119 -57q24 -35 24 -111v-303q0 -75 -32 -109q-34 -35 -91 -35q-27 0 -51 9v70q25 -9 47 -9q32 0 46 22q9 15 9 60v293q0 51 -19 76q-23 30 -68 30q-46 0 -73 -32q-30 -35 -30 -112v-177h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10100",
    unicode: "\u0453",
    horizAdvX: 318,
    d: "M68 0v415h246v-66h-174v-349h-72zM252 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10101",
    unicode: "\u0454",
    horizAdvX: 438,
    d: "M393 385v-86q-52 62 -130 62q-51 0 -92.5 -31.5t-51.5 -85.5h217v-64h-218q7 -57 48 -92.5t96 -35.5q80 0 134 65v-86q-59 -43 -132 -43q-97 0 -159.5 61.5t-62.5 155.5q0 95 63 157.5t159 62.5q72 0 129 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10102",
    unicode: "\u0455",
    horizAdvX: 352,
    d: "M298 350l-59 -31q-17 42 -58 42q-21 0 -35.5 -12t-14.5 -35q0 -21 13.5 -31.5t53.5 -27.5q79 -33 104 -64q22 -27 22 -67q0 -63 -40.5 -99.5t-102.5 -36.5q-12 0 -26 2.5t-38.5 11t-46.5 32.5t-34 60l62 26q25 -68 84 -68q33 0 50.5 20t17.5 46q0 14 -4.5 24.5t-15 18.5 t-20 13t-27.5 13q-80 35 -101 61q-19 24 -19 61q0 54 33.5 85t87.5 31q79 0 114 -75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10103",
    unicode: "\u0456",
    horizAdvX: 208,
    d: "M68 415h72v-415h-72v415zM53 572q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10104",
    unicode: "\u0457",
    horizAdvX: 208,
    d: "M68 415h72v-415h-72v415zM9 573q0 20 12.5 35t29.5 15t29.5 -15t12.5 -35t-12.5 -35t-29.5 -15t-29.5 15t-12.5 35zM115 573q0 20 12.5 35t29.5 15t29.5 -15t12.5 -35t-12.5 -35t-29.5 -15t-29.5 15t-12.5 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10105",
    unicode: "\u0458",
    horizAdvX: 208,
    d: "M68 415h72v-645h-72v645zM53 572q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10106",
    unicode: "\u0459",
    horizAdvX: 642,
    d: "M382 415v-159h74q86 0 126 -41q32 -32 32 -87q0 -58 -37 -93t-122 -35h-145v349h-148v-187q0 -81 -32 -120q-36 -44 -100 -44q-8 0 -22 2v66q10 -2 16 -2q35 0 52 27q14 22 14 71v253h292zM382 64h67q45 0 64 11q27 18 27 53q0 36 -26 52q-18 12 -64 12h-68v-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10107",
    unicode: "\u045A",
    horizAdvX: 668,
    d: "M68 0v415h72v-157h196v157h72v-159h74q86 0 126 -41q32 -32 32 -87q0 -58 -37 -93t-122 -35h-145v192h-196v-192h-72zM408 64h67q45 0 64 11q27 18 27 53q0 36 -26 52q-18 12 -64 12h-68v-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10108",
    unicode: "\u045B",
    horizAdvX: 470,
    d: "M68 0v514h-68v60h68v155h72v-155h200v-60h-200v-187q44 58 119 58q80 0 119 -57q24 -35 24 -111v-217h-72v215q0 51 -19 76q-23 30 -68 30q-46 0 -73 -32q-30 -35 -30 -112v-177h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10109",
    unicode: "\u045C",
    horizAdvX: 422,
    d: "M68 415h72v-170l168 170h88l-180 -185l202 -230h-94l-162 182l-22 -21v-161h-72v415zM273 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10110",
    unicode: "\u045E",
    horizAdvX: 460,
    d: "M67 -230l132 269l-191 376h82l147 -297l135 297h80l-305 -645h-80zM95 594l60 23q18 -60 85 -60t85 60l60 -23q-16 -45 -54.5 -71t-90.5 -26t-90.5 26t-54.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10193",
    unicode: "\u045F",
    horizAdvX: 466,
    d: "M68 0v415h72v-349h186v349h72v-415h-132v-120h-66v120h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10146",
    unicode: "\u0462",
    horizAdvX: 610,
    d: "M174 0v517h-160v70h160v107h74v-107h180v-70h-180v-127h90q230 0 230 -188q0 -94 -58.5 -148t-157.5 -54h-178zM248 320v-250h86q85 0 123 37q35 33 35 95q0 72 -54 101q-31 17 -112 17h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10194",
    unicode: "\u0463",
    horizAdvX: 430,
    d: "M8 415h90v252h72v-252h120v-66h-120v-93h74q86 0 126 -41q32 -32 32 -87q0 -58 -37 -93t-122 -35h-145v349h-90v66zM170 64h67q45 0 64 11q27 18 27 53q0 36 -26 52q-18 12 -64 12h-68v-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10147",
    unicode: "\u0472",
    horizAdvX: 792,
    d: "M396 -12q-145 0 -245.5 99t-100.5 246q0 148 100.5 246.5t245.5 98.5t245.5 -98.5t100.5 -246.5q0 -147 -100.5 -246t-245.5 -99zM129 380h534q-18 106 -96 167t-171 61t-171 -61t-96 -167zM666 310h-540q10 -112 88.5 -182t181.5 -70t181.5 70t88.5 182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10195",
    unicode: "\u0473",
    horizAdvX: 524,
    d: "M262 -12q-95 0 -157.5 62t-62.5 156q0 95 62.5 157t157.5 62t157.5 -62t62.5 -157q0 -94 -62.5 -156t-157.5 -62zM120 244h284q-10 55 -50.5 86t-91.5 31t-91.5 -31t-50.5 -86zM406 180h-288q5 -57 47 -92.5t97 -35.5t96.5 35.5t47.5 92.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10148",
    unicode: "\u0474",
    horizAdvX: 556,
    d: "M8 667h82l188 -509l188 509h82l-270 -707z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10196",
    unicode: "\u0475",
    horizAdvX: 424,
    d: "M8 415h80l124 -280l124 280h80l-204 -442z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10050",
    unicode: "\u0490",
    horizAdvX: 404,
    d: "M86 0v667h234v140h70v-210h-230v-597h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10098",
    unicode: "\u0491",
    horizAdvX: 328,
    d: "M68 0v415h180v110h66v-176h-174v-349h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0492",
    unicode: "\u0492",
    horizAdvX: 404,
    d: "M86 0v334h-86v66h86v267h304v-70h-230v-197h136v-66h-136v-334h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0493",
    unicode: "\u0493",
    horizAdvX: 318,
    d: "M68 0v188h-68v60h68v167h246v-66h-174v-101h100v-60h-100v-188h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0494",
    unicode: "\u0494",
    horizAdvX: 558,
    d: "M402 597h-242v-212q71 23 137 23q120 0 175 -67q44 -54 44 -147q0 -112 -70 -163q-49 -37 -134 -37q-28 0 -68 6v70q28 -6 63 -6q61 0 93 27q40 34 40 104q0 63 -28 97q-39 46 -122 46q-64 0 -130 -23v-315h-74v667h316v-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0495",
    unicode: "\u0495",
    horizAdvX: 430,
    d: "M68 0v415h246v-66h-174v-113h30q110 0 167 -57q51 -53 51 -139q0 -109 -79 -182q-62 -57 -146 -66v70q54 7 96 48q53 50 53 131q0 66 -39 99q-34 30 -103 30h-30v-170h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0496",
    unicode: "\u0496",
    horizAdvX: 810,
    d: "M368 667h74v-286l254 286h92l-280 -311l231 -286h57v-210h-70v140h-24l-244 305l-16 -18v-287h-74v287l-16 18l-244 -305h-94l288 356l-280 311h92l254 -286v286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0497",
    unicode: "\u0497",
    horizAdvX: 596,
    d: "M262 415h72v-170l156 170h84l-180 -192l140 -157h58v-176h-66v110h-24l-154 175l-14 -14v-161h-72v161l-14 14l-154 -175h-90l198 223l-180 192h84l156 -170v170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0498",
    unicode: "\u0498",
    horizAdvX: 576,
    d: "M157 536l-57 45q32 47 78 72t109 25q96 0 149 -51q48 -46 48 -118q0 -51 -27 -89q-27 -36 -65 -53q52 -12 87 -47q47 -47 47 -122q0 -84 -56 -143q-57 -59 -142 -65v-150h-70v150q-77 7 -135 57q-48 41 -73 101l72 32q16 -45 47 -73q50 -49 128 -49q73 0 115 40 q38 38 38 99q0 55 -36 88q-42 39 -142 39h-60v70h60q66 0 101 31q35 29 35 82q0 43 -27 70q-31 31 -90 31q-52 0 -88 -25q-28 -20 -46 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0499",
    unicode: "\u0499",
    horizAdvX: 422,
    d: "M122 309l-50 41q24 35 53 52q37 23 95 23q59 0 94 -29q36 -30 36 -81q0 -31 -14 -54q-11 -19 -33 -31q28 -7 48 -27q29 -29 29 -77q0 -52 -38 -92q-39 -41 -95 -44v-110h-66v110q-46 4 -84 33q-32 25 -55 71l62 26q14 -30 37 -47q28 -21 68 -21q43 0 68 15q31 19 31 59 q0 31 -25 48q-22 14 -68 14h-42v66h35q36 0 54 11q22 15 22 39q0 26 -18 42q-18 15 -56 15q-31 0 -54 -16t-34 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049A",
    unicode: "\u049A",
    horizAdvX: 568,
    d: "M86 667h74v-286l284 286h100l-312 -311l259 -286h63v-210h-70v140h-32l-273 306l-19 -19v-287h-74v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049B",
    unicode: "\u049B",
    horizAdvX: 422,
    d: "M68 415h72v-170l168 170h88l-180 -185l144 -164h58v-176h-66v110h-28l-162 182l-22 -21v-161h-72v415z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049C",
    unicode: "\u049C",
    horizAdvX: 644,
    d: "M86 667h74v-291h80v140h66v-140l233 291h82l-255 -315l264 -352h-88l-236 310v-150h-66v150h-80v-310h-74v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049D",
    unicode: "\u049D",
    horizAdvX: 450,
    d: "M68 415h72v-170h50v100h60v-100l109 170h78l-131 -199l140 -216h-80l-116 185v-110h-60v110h-50v-185h-72v415z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A0",
    unicode: "\u04A0",
    horizAdvX: 656,
    d: "M174 0v597h-160v70h234v-286l284 286h100l-312 -311l322 -356h-102l-273 306l-19 -19v-287h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A1",
    unicode: "\u04A1",
    horizAdvX: 452,
    d: "M98 0v349h-90v66h162v-170l168 170h88l-180 -185l202 -230h-94l-162 182l-22 -21v-161h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A2",
    unicode: "\u04A2",
    horizAdvX: 666,
    d: "M86 0v667h74v-271h342v271h74v-597h76v-210h-70v140h-80v326h-342v-326h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A3",
    unicode: "\u04A3",
    horizAdvX: 484,
    d: "M68 0v415h72v-170h196v170h72v-349h68v-176h-66v110h-74v179h-196v-179h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A4",
    unicode: "\u04A4",
    horizAdvX: 820,
    d: "M86 0v667h74v-271h342v271h304v-70h-230v-597h-74v326h-342v-326h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A5",
    unicode: "\u04A5",
    horizAdvX: 586,
    d: "M68 0v415h72v-170h196v170h246v-66h-174v-349h-72v179h-196v-179h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AA",
    unicode: "\u04AA",
    horizAdvX: 646,
    d: "M596 612v-92q-40 40 -87 62q-55 26 -115 26q-112 0 -190 -78q-78 -80 -78 -200q0 -117 76 -193q79 -79 193 -79q59 0 114 26q45 21 87 61v-92q-64 -49 -163 -63v-150h-70v150q-127 8 -217 99q-96 98 -96 242t94 244q98 103 255 103q117 0 197 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AB",
    unicode: "\u04AB",
    horizAdvX: 438,
    d: "M393 385v-86q-50 62 -130 62q-63 0 -106 -43q-41 -41 -41 -112q0 -65 36 -105q43 -49 113 -49q77 0 131 65v-86q-40 -35 -94 -40v-111h-66v110q-80 6 -135 61q-59 59 -59 153q0 96 61 157q64 64 164 64q69 0 126 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AE",
    unicode: "\u04AE",
    horizAdvX: 530,
    d: "M227 0v287l-219 380h86l170 -298l172 298h86l-221 -380v-287h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u04AF",
    horizAdvX: 424,
    d: "M8 415h80l124 -280l124 280h80l-168 -364v-281h-72v281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 530,
    d: "M227 0v221h-190v66h190l-219 380h86l170 -298l172 298h86l-221 -380h190v-66h-190v-221h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 424,
    d: "M8 415h80l124 -280l124 280h80l-168 -364v-51h120v-66h-120v-164h-72v164h-120v66h120v51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B2",
    unicode: "\u04B2",
    horizAdvX: 520,
    d: "M14 0l197 345l-179 322h84l138 -251l142 251h84l-183 -322l154 -275h55v-210h-70v140h-30l-153 274l-155 -274h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B3",
    unicode: "\u04B3",
    horizAdvX: 454,
    d: "M8 0l177 222l-151 193h88l107 -141l109 141h88l-152 -194l121 -155h51v-176h-66v110h-22l-131 169l-131 -169h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B6",
    unicode: "\u04B6",
    horizAdvX: 594,
    d: "M430 0v286q-93 -7 -138 -7q-119 0 -165 36q-61 47 -61 155v197h74v-187q0 -81 40 -110q28 -21 116 -21q59 0 134 7v311h74v-597h76v-210h-70v140h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B7",
    unicode: "\u04B7",
    horizAdvX: 438,
    d: "M290 0v163q-58 -9 -98 -9q-68 0 -101 30q-35 31 -35 102v129h72v-119q0 -34 9 -49q14 -27 63 -27q44 0 90 9v186h72v-349h68v-176h-66v110h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B8",
    unicode: "\u04B8",
    horizAdvX: 620,
    d: "M460 0v286q-47 -3 -116 -6v-140h-66v139q-104 0 -151 36q-61 46 -61 155v197h74v-187q0 -81 40 -110q32 -24 98 -21v147h66v-146q65 2 116 6v311h74v-667h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B9",
    unicode: "\u04B9",
    horizAdvX: 460,
    d: "M320 0v163q-30 -6 -64 -6v-102h-60v99q-66 -4 -105 30q-35 30 -35 102v129h72v-119q0 -35 9 -49q17 -28 59 -26v104h60v-103q29 0 64 7v186h72v-415h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BA",
    unicode: "\u04BA",
    horizAdvX: 590,
    d: "M160 667v-266q93 7 138 7q119 0 165 -36q61 -47 61 -155v-217h-74v207q0 81 -40 110q-28 21 -116 21q-59 0 -134 -7v-331h-74v667h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BB",
    unicode: "\u04BB",
    horizAdvX: 470,
    d: "M68 0v729h72v-362q44 58 119 58q80 0 119 -57q24 -35 24 -111v-257h-72v255q0 51 -19 76q-23 30 -68 30q-46 0 -73 -32q-30 -35 -30 -112v-217h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C0",
    unicode: "\u04C0",
    horizAdvX: 246,
    d: "M86 667h74v-667h-74v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C1",
    unicode: "\u04C1",
    horizAdvX: 810,
    d: "M368 667h74v-286l254 286h92l-280 -311l288 -356h-94l-244 305l-16 -18v-287h-74v287l-16 18l-244 -305h-94l288 356l-280 311h92l254 -286v286zM250 818l70 23q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l70 -23q-4 -11 -11.5 -23 t-24.5 -31t-48 -31t-71 -12t-71 12t-48 31t-24.5 31t-11.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C2",
    unicode: "\u04C2",
    horizAdvX: 596,
    d: "M262 415h72v-170l156 170h84l-180 -192l198 -223h-90l-154 175l-14 -14v-161h-72v161l-14 14l-154 -175h-90l198 223l-180 192h84l156 -170v170zM153 594l60 23q18 -60 85 -60t85 60l60 -23q-16 -45 -54.5 -71t-90.5 -26t-90.5 26t-54.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C3",
    unicode: "\u04C3",
    horizAdvX: 584,
    d: "M86 667h74v-306l284 306h100l-260 -272q121 0 182 -61q76 -75 76 -226q0 -143 -67 -212q-54 -56 -151 -56q-58 0 -111 21l21 71q38 -22 86 -22q61 0 96 33q51 49 51 158q0 138 -70 193q-47 36 -123 36q-55 0 -114 -13v-317h-74v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C4",
    unicode: "\u04C4",
    horizAdvX: 414,
    d: "M68 415h72v-170l168 170h88l-182 -185q77 -5 123 -51q51 -51 51 -135q0 -113 -79 -186q-62 -57 -146 -66v70q54 7 96 48q53 51 53 128q0 67 -39 102q-35 30 -103 30h-30v-170h-72v415z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C7",
    unicode: "\u04C7",
    horizAdvX: 662,
    d: "M86 0v667h74v-271h342v271h74v-753q0 -79 -34 -113q-31 -31 -89 -31q-30 0 -53 9v72q19 -9 42 -9q30 0 44 13q16 15 16 55v416h-342v-326h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C8",
    unicode: "\u04C8",
    horizAdvX: 476,
    d: "M68 0v415h72v-170h196v170h72v-501q0 -75 -32 -109q-34 -35 -91 -35q-27 0 -51 9v70q25 -9 47 -9q32 0 46 22q9 15 9 60v257h-196v-179h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D0",
    unicode: "\u04D0",
    horizAdvX: 622,
    d: "M532 0l-78 188h-284l-80 -188h-82l307 699l299 -699h-82zM199 258h226l-112 267zM160 818l70 23q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l70 -23q-4 -11 -11.5 -23t-24.5 -31t-48 -31t-71 -12t-71 12t-48 31t-24.5 31t-11.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D1",
    unicode: "\u04D1",
    horizAdvX: 526,
    d: "M386 356v59h72v-415h-72v58q-54 -70 -142 -70q-84 0 -143 58t-59 162q0 102 58.5 159.5t143.5 57.5q90 0 142 -69zM252 361q-57 0 -96.5 -40.5t-39.5 -112.5q0 -69 36.5 -112.5t99.5 -43.5t100.5 45t37.5 110q0 74 -42 114t-96 40zM109 594l60 23q18 -60 85 -60t85 60 l60 -23q-16 -45 -54.5 -71t-90.5 -26t-90.5 26t-54.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D2",
    unicode: "\u04D2",
    horizAdvX: 622,
    d: "M532 0l-78 188h-284l-80 -188h-82l307 699l299 -699h-82zM199 258h226l-112 267zM169 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM359 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D3",
    unicode: "\u04D3",
    horizAdvX: 526,
    d: "M386 356v59h72v-415h-72v58q-54 -70 -142 -70q-84 0 -143 58t-59 162q0 102 58.5 159.5t143.5 57.5q90 0 142 -69zM252 361q-57 0 -96.5 -40.5t-39.5 -112.5q0 -69 36.5 -112.5t99.5 -43.5t100.5 45t37.5 110q0 74 -42 114t-96 40zM103 550q0 20 15 35t35 15t35 -15 t15 -35t-15 -35t-35 -15t-35 15t-15 35zM277 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D4",
    unicode: "\u04D4",
    horizAdvX: 900,
    d: "M538 0l-79 187h-284l-79 -187h-82l297 667h293l29 -70h-269l83 -198h264l29 -70h-262l108 -259h271l29 -70h-348zM207 257h223l-110 261z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D5",
    unicode: "\u04D5",
    horizAdvX: 774,
    d: "M667 140l60 -36q-61 -116 -187 -116q-107 0 -163 83q-47 -83 -156 -83q-77 0 -128 35t-51 100t49 101t124 36q70 0 119 -35q2 54 -19 88q-28 48 -99 48q-56 0 -128 -26v68q67 22 129 22q117 0 157 -84q52 84 160 84q91 0 144.5 -61.5t53.5 -163.5v-7h-324 q2 -61 39.5 -101t91.5 -40q41 0 75 25t53 63zM413 253h245q-7 50 -41 79t-82 29q-46 0 -80 -29t-42 -79zM221 196q-51 0 -79 -20.5t-28 -52.5q0 -28 24.5 -49.5t80.5 -21.5q57 0 84 22.5t27 51.5q0 26 -26.5 48t-82.5 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D6",
    unicode: "\u04D6",
    horizAdvX: 482,
    d: "M432 667v-70h-272v-198h264v-70h-264v-259h272v-70h-346v667h346zM105 818l70 23q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l70 -23q-4 -11 -11.5 -23t-24.5 -31t-48 -31t-71 -12t-71 12t-48 31t-24.5 31t-11.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D7",
    unicode: "\u04D7",
    horizAdvX: 481,
    d: "M376 139l60 -33q-21 -40 -51 -67q-57 -51 -138 -51q-84 0 -144.5 54.5t-60.5 162.5q0 95 54.5 157.5t146.5 62.5q104 0 157 -76q42 -60 39 -156h-323q1 -63 39 -102t93 -39q49 0 85 30q28 24 43 57zM121 253h244q-9 49 -42.5 78.5t-79.5 29.5q-45 0 -79.5 -30.5 t-42.5 -77.5zM96 594l60 23q18 -60 85 -60t85 60l60 -23q-16 -45 -54.5 -71t-90.5 -26t-90.5 26t-54.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D8",
    unicode: "\u04D8",
    horizAdvX: 756,
    d: "M132 483l-55 50q33 45 77 79q86 66 204 66q149 0 248.5 -99.5t99.5 -245.5t-98.5 -245.5t-245.5 -99.5q-83 0 -146.5 34t-101.5 86q-64 87 -64 211v16h580q0 114 -77 193.5t-196 79.5q-96 0 -162 -56q-34 -28 -63 -69zM623 265h-497q2 -52 27 -95q29 -51 83.5 -81.5 t120.5 -30.5q96 0 171 58.5t95 148.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10846",
    unicode: "\u04D9",
    horizAdvX: 482,
    d: "M105 274l-60 33q21 40 51 67q56 51 138 51q84 0 145 -55t61 -162q0 -95 -55 -157.5t-147 -62.5q-103 0 -158 76q-45 64 -38 156h324q-1 63 -39 102t-94 39q-51 0 -85 -30q-28 -24 -43 -57zM360 160h-244q8 -48 41 -78t81 -30q45 0 79.5 30.5t42.5 77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DA",
    unicode: "\u04DA",
    horizAdvX: 756,
    d: "M132 483l-55 50q33 45 77 79q86 66 204 66q149 0 248.5 -99.5t99.5 -245.5t-98.5 -245.5t-245.5 -99.5q-83 0 -146.5 34t-101.5 86q-64 87 -64 211v16h580q0 114 -77 193.5t-196 79.5q-96 0 -162 -56q-34 -28 -63 -69zM623 265h-497q2 -52 27 -95q29 -51 83.5 -81.5 t120.5 -30.5q96 0 171 58.5t95 148.5zM214 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM404 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DB",
    unicode: "\u04DB",
    horizAdvX: 482,
    d: "M105 274l-60 33q21 40 51 67q56 51 138 51q84 0 145 -55t61 -162q0 -95 -55 -157.5t-147 -62.5q-103 0 -158 76q-45 64 -38 156h324q-1 63 -39 102t-94 39q-51 0 -85 -30q-28 -24 -43 -57zM360 160h-244q8 -48 41 -78t81 -30q45 0 79.5 30.5t42.5 77.5zM105 550 q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM279 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DC",
    unicode: "\u04DC",
    horizAdvX: 810,
    d: "M368 667h74v-286l254 286h92l-280 -311l288 -356h-94l-244 305l-16 -18v-287h-74v287l-16 18l-244 -305h-94l288 356l-280 311h92l254 -286v286zM259 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM449 784q0 21 15 36t36 15t36 -15t15 -36 t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DD",
    unicode: "\u04DD",
    horizAdvX: 596,
    d: "M262 415h72v-170l156 170h84l-180 -192l198 -223h-90l-154 175l-14 -14v-161h-72v161l-14 14l-154 -175h-90l198 223l-180 192h84l156 -170v170zM161 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM335 550q0 20 15 35t35 15t35 -15t15 -35 t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DE",
    unicode: "\u04DE",
    horizAdvX: 576,
    d: "M157 536l-57 45q65 97 191 97q90 0 141 -47q52 -47 52 -123q0 -49 -25.5 -85.5t-66.5 -55.5q65 -15 99.5 -62t34.5 -110q0 -104 -83 -163q-64 -44 -152 -44q-91 0 -151 46t-90 114l72 32q20 -56 66 -89t106 -33q61 0 102 28q54 38 54 107q0 131 -178 131h-60v70h60 q66 0 101 32t35 81q0 43 -27 70q-30 31 -90 31q-84 0 -134 -72zM144 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM334 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DF",
    unicode: "\u04DF",
    horizAdvX: 422,
    d: "M122 309l-50 41q24 35 53 52q39 23 91 23q63 0 98 -29q36 -31 36 -79q0 -58 -47 -87q30 -7 48 -27q29 -31 29 -76q0 -67 -54 -107q-44 -32 -118 -32q-66 0 -111 35q-34 25 -55 71l62 26q11 -28 37 -47q28 -21 68 -21q47 0 70 16q29 19 29 58q0 32 -25 48q-21 14 -68 14 h-42v66h35q38 0 54 11q22 14 22 38q0 28 -18 43q-17 15 -53 15q-31 0 -57 -16q-22 -14 -34 -36zM83 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM257 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E2",
    unicode: "\u04E2",
    horizAdvX: 710,
    d: "M550 0v509l-464 -539v697h74v-511l464 539v-695h-74zM200 733v64h320v-64h-320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E3",
    unicode: "\u04E3",
    horizAdvX: 492,
    d: "M68 415h72v-274l284 306v-447h-72v277l-284 -306v444zM95 513v60h302v-60h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E4",
    unicode: "\u04E4",
    horizAdvX: 710,
    d: "M550 0v509l-464 -539v697h74v-511l464 539v-695h-74zM214 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM404 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E5",
    unicode: "\u04E5",
    horizAdvX: 492,
    d: "M68 415h72v-274l284 306v-447h-72v277l-284 -306v444zM109 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM283 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E6",
    unicode: "\u04E6",
    horizAdvX: 794,
    d: "M397 -12q-146 0 -246.5 99t-100.5 246q0 148 101 246.5t246 98.5t246 -98.5t101 -246.5q0 -147 -100.5 -246t-246.5 -99zM397 608q-113 0 -192 -80t-79 -195t79 -195t192 -80t192 80t79 195t-79 195t-192 80zM251 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15 t-36 15t-15 36zM441 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E7",
    unicode: "\u04E7",
    horizAdvX: 524,
    d: "M262 -12q-95 0 -157.5 62t-62.5 156q0 95 62.5 157t157.5 62t157.5 -62t62.5 -157q0 -94 -62.5 -156t-157.5 -62zM262 361q-61 0 -103.5 -41.5t-42.5 -113.5t43 -113t103 -41t103 41t43 113q0 73 -42.5 114t-103.5 41zM125 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35 t-35 -15t-35 15t-15 35zM299 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E8",
    unicode: "\u04E8",
    horizAdvX: 792,
    d: "M396 -12q-145 0 -245.5 99t-100.5 246q0 148 100.5 246.5t245.5 98.5t245.5 -98.5t100.5 -246.5q0 -147 -100.5 -246t-245.5 -99zM129 380h534q-18 106 -96 167t-171 61t-171 -61t-96 -167zM666 310h-540q10 -112 88.5 -182t181.5 -70t181.5 70t88.5 182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E9",
    unicode: "\u04E9",
    horizAdvX: 524,
    d: "M262 -12q-95 0 -157.5 62t-62.5 156q0 95 62.5 157t157.5 62t157.5 -62t62.5 -157q0 -94 -62.5 -156t-157.5 -62zM120 244h284q-10 55 -50.5 86t-91.5 31t-91.5 -31t-50.5 -86zM406 180h-288q5 -57 47 -92.5t97 -35.5t96.5 35.5t47.5 92.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EA",
    unicode: "\u04EA",
    horizAdvX: 792,
    d: "M396 -12q-145 0 -245.5 99t-100.5 246q0 148 100.5 246.5t245.5 98.5t245.5 -98.5t100.5 -246.5q0 -147 -100.5 -246t-245.5 -99zM129 380h534q-18 106 -96 167t-171 61t-171 -61t-96 -167zM666 310h-540q10 -112 88.5 -182t181.5 -70t181.5 70t88.5 182zM251 784 q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM441 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EB",
    unicode: "\u04EB",
    horizAdvX: 524,
    d: "M262 -12q-95 0 -157.5 62t-62.5 156q0 95 62.5 157t157.5 62t157.5 -62t62.5 -157q0 -94 -62.5 -156t-157.5 -62zM120 244h284q-10 55 -50.5 86t-91.5 31t-91.5 -31t-50.5 -86zM406 180h-288q5 -57 47 -92.5t97 -35.5t96.5 35.5t47.5 92.5zM125 550q0 20 15 35t35 15 t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM299 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EE",
    unicode: "\u04EE",
    horizAdvX: 568,
    d: "M8 667h90l208 -393l174 393h80l-301 -667h-80l85 186zM135 733v64h320v-64h-320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EF",
    unicode: "\u04EF",
    horizAdvX: 460,
    d: "M67 -230l132 269l-191 376h82l147 -297l135 297h80l-305 -645h-80zM79 513v60h302v-60h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F0",
    unicode: "\u04F0",
    horizAdvX: 568,
    d: "M8 667h90l208 -393l174 393h80l-301 -667h-80l85 186zM149 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM339 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F1",
    unicode: "\u04F1",
    horizAdvX: 460,
    d: "M67 -230l132 269l-191 376h82l147 -297l135 297h80l-305 -645h-80zM103 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM277 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F2",
    unicode: "\u04F2",
    horizAdvX: 568,
    d: "M8 667h90l208 -393l174 393h80l-301 -667h-80l85 186zM288 882l70 -40l-147 -122l-43 26zM438 882l70 -40l-147 -122l-43 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F3",
    unicode: "\u04F3",
    horizAdvX: 460,
    d: "M67 -230l132 269l-191 376h82l147 -297l135 297h80l-305 -645h-80zM230 666l72 -32l-137 -136l-41 23zM364 666l70 -32l-135 -136l-41 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F4",
    unicode: "\u04F4",
    horizAdvX: 590,
    d: "M430 0v286q-93 -7 -138 -7q-119 0 -165 36q-61 47 -61 155v197h74v-187q0 -81 40 -110q28 -21 116 -21q59 0 134 7v311h74v-667h-74zM144 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM334 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15 t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F5",
    unicode: "\u04F5",
    horizAdvX: 430,
    d: "M290 0v163q-58 -9 -98 -9q-68 0 -101 30q-35 31 -35 102v129h72v-119q0 -34 9 -49q14 -27 63 -27q44 0 90 9v186h72v-415h-72zM73 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM247 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15 t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F8",
    unicode: "\u04F8",
    horizAdvX: 710,
    d: "M86 0v667h74v-277h90q230 0 230 -188q0 -94 -58.5 -148t-157.5 -54h-178zM160 320v-250h86q85 0 123 37q35 33 35 95q0 72 -54 101q-31 17 -112 17h-78zM550 667h74v-667h-74v667zM209 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM399 784 q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F9",
    unicode: "\u04F9",
    horizAdvX: 562,
    d: "M68 0v415h72v-159h74q86 0 126 -41q32 -32 32 -87q0 -58 -37 -93t-122 -35h-145zM140 64h67q45 0 64 11q27 18 27 53q0 36 -26 52q-18 12 -64 12h-68v-128zM422 0v415h72v-415h-72zM144 550q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM318 550 q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2010",
    unicode: "\u2010",
    horizAdvX: 320,
    d: "M50 176v74h220v-74h-220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2011",
    unicode: "\u2011",
    horizAdvX: 320,
    d: "M50 176v74h220v-74h-220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "figuredash",
    unicode: "\u2012",
    horizAdvX: 580,
    d: "M70 307v64h440v-64h-440z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 580,
    d: "M70 181v64h440v-64h-440z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 800,
    d: "M70 181v64h660v-64h-660z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii00208",
    unicode: "\u2015",
    horizAdvX: 800,
    d: "M70 181v64h660v-64h-660z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 264,
    d: "M206 667l-83 -231l-65 24l101 226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 264,
    d: "M58 460l81 231l67 -24l-101 -226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 308,
    d: "M58 -133l81 231l67 -24l-101 -226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 410,
    d: "M206 667l-83 -231l-65 24l101 226zM352 667l-81 -231l-67 24l101 226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 410,
    d: "M58 460l81 231l67 -24l-101 -226zM204 460l83 231l65 -24l-101 -226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 454,
    d: "M58 -133l81 231l67 -24l-101 -226zM204 -133l83 231l65 -24l-101 -226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 568,
    d: "M248 503v226h72v-226h148v-68h-148v-605h-72v605h-148v68h148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 568,
    d: "M248 503v226h72v-226h148v-68h-148v-277h148v-68h-148v-266h-72v266h-148v68h148v277h-148v68h148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 1000,
    d: "M360 340q0 58 41 99t99 41t99 -41t41 -99t-41 -99t-99 -41t-99 41t-41 99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 746,
    d: "M75 40q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM323 40q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35zM571 40q0 20 15 35t35 15t35 -15t15 -35t-15 -35t-35 -15t-35 15t-15 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1060,
    d: "M178 673q61 0 103 -42t42 -103t-42 -103t-103 -42t-103 42t-42 103t42 103t103 42zM178 438q36 0 60.5 26.5t24.5 63.5t-24.5 63.5t-60.5 26.5q-35 0 -60 -26.5t-25 -63.5t25 -63.5t60 -26.5zM141 10l389 670l39 -22l-389 -671zM532 283q61 0 103 -42t42 -103t-42 -103 t-103 -42t-103 42t-42 103t42 103t103 42zM532 48q36 0 60.5 26.5t24.5 63.5t-24.5 63.5t-60.5 26.5q-35 0 -60 -26.5t-25 -63.5t25 -63.5t60 -26.5zM882 283q61 0 103 -42t42 -103t-42 -103t-103 -42t-103 42t-42 103t42 103t103 42zM882 48q36 0 60.5 26.5t24.5 63.5 t-24.5 63.5t-60.5 26.5q-35 0 -60 -26.5t-25 -63.5t25 -63.5t60 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 282,
    d: "M112 212l120 -146l-46 -36l-150 182l150 188l46 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 282,
    d: "M170 218l-120 146l46 36l150 -182l-150 -188l-46 37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 126,
    d: "M-150 10l388 670l38 -22l-388 -671z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2080",
    unicode: "\u2080",
    horizAdvX: 350,
    d: "M175 -7q-63 0 -106 60q-41 55 -41 147q0 90 41 147q42 59 106 59t106 -59q41 -57 41 -147q0 -92 -41 -147q-43 -60 -106 -60zM175 360q-41 0 -67 -41q-28 -43 -28 -119q0 -74 28 -118q28 -43 67 -43t67 43t28 118q0 77 -28 119q-26 41 -67 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2081",
    unicode: "\u2081",
    horizAdvX: 350,
    d: "M166 0v354h-78l24 46h106v-400h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2082",
    unicode: "\u2082",
    horizAdvX: 350,
    d: "M297 0h-265l146 169q35 41 46 58q22 32 22 61q0 30 -20.5 51t-55.5 21q-45 0 -65 -34q-12 -21 -12 -48h-50q3 54 30 87q35 41 96 41q57 0 93 -33t36 -86q0 -39 -32 -85q-15 -22 -55 -67l-77 -89h163v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2083",
    unicode: "\u2083",
    horizAdvX: 350,
    d: "M102 296h-50q2 37 19 64q30 46 97 46q61 0 88.5 -33.5t27.5 -73.5q0 -65 -52 -89q58 -22 58 -97q0 -51 -34.5 -85.5t-92.5 -34.5q-46 0 -74.5 20t-40.5 49q-8 20 -10 47h50q1 -22 14 -40q22 -30 59 -30q34 0 55.5 21.5t21.5 54.5q0 48 -39 65q-19 9 -46 7v46q26 -2 46 8 q33 17 33 57q0 26 -16 44t-48 18q-34 0 -51 -21q-13 -16 -15 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2084",
    unicode: "\u2084",
    horizAdvX: 350,
    d: "M269 422v-311h49v-46h-49v-65h-50v65h-205zM104 111h115v164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2085",
    unicode: "\u2085",
    horizAdvX: 350,
    d: "M297 400v-46h-134l-22 -81q16 2 25 2q62 0 98 -38.5t36 -97.5q0 -68 -45.5 -107t-107.5 -39q-51 0 -90 31q-23 18 -35 41l39 30q10 -19 26 -32q28 -24 62 -24q41 0 70 28.5t29 68.5t-28 66.5t-71 26.5q-39 0 -77 -28l58 199h167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2086",
    unicode: "\u2086",
    horizAdvX: 350,
    d: "M202 413l42 -31l-92 -123q14 5 31 5q60 0 97 -38t37 -96q0 -60 -39.5 -98.5t-101.5 -38.5q-61 0 -102 38.5t-41 97.5q0 44 33 92zM175 39q43 0 66.5 27.5t23.5 62.5q0 38 -26.5 63.5t-64.5 25.5t-63.5 -25.5t-25.5 -63.5q0 -35 23 -62.5t67 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2087",
    unicode: "\u2087",
    horizAdvX: 350,
    d: "M32 18l222 336h-214v46h300l-267 -410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2088",
    unicode: "\u2088",
    horizAdvX: 350,
    d: "M109 208q-48 29 -48 88q0 46 30.5 78t83.5 32t83.5 -32t30.5 -78q0 -59 -48 -88q61 -26 61 -98q0 -50 -34 -83.5t-93 -33.5t-93 33.5t-34 83.5q0 72 61 98zM175 229q29 0 47 19t18 47q0 30 -18.5 47.5t-46.5 17.5t-46.5 -17.5t-18.5 -47.5q0 -28 18 -47t47 -19zM175 185 q-33 0 -54 -21t-21 -52q0 -32 21 -52.5t54 -20.5t54 20.5t21 52.5q0 31 -21 52t-54 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2089",
    unicode: "\u2089",
    horizAdvX: 350,
    d: "M148 -14l-42 31l92 123q-14 -5 -31 -5q-60 0 -97 38t-37 96q0 60 39.5 98.5t101.5 38.5q61 0 102 -38.5t41 -97.5q0 -44 -33 -92zM175 360q-43 0 -66.5 -27.5t-23.5 -62.5q0 -38 26.5 -63.5t64.5 -25.5t63.5 25.5t25.5 63.5q0 35 -23 62.5t-67 27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 568,
    d: "M528 622l-33 -67q-63 53 -151 53q-39 0 -72.5 -12.5t-54.5 -30.5t-37.5 -42t-25 -43.5t-13.5 -39.5h319l-26 -66h-305q-6 -39 -1 -78h281l-26 -66h-244q15 -76 70 -124t137 -48q100 0 182 77v-92q-82 -55 -186 -55q-122 0 -195 69.5t-88 172.5h-67l26 66h34q-5 41 1 78 h-61l26 66h43q21 100 96 169t192 69q99 0 179 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 568,
    d: "M158 535l-59 39q35 45 79 71q55 33 127 33q70 0 112 -36q42 -35 42 -89q0 -62 -49 -113h93v-56h-138l-89 -88h227v-56h-278q-45 -42 -45 -100q0 -34 25 -57q27 -25 74 -25q56 0 97 38q30 29 49 74l68 -30q-20 -55 -59 -92q-61 -60 -159 -60q-74 0 -118 33q-53 42 -53 114 q0 57 39 105h-77v56h122l89 88h-211v56h262q57 50 57 95q0 30 -22 50q-24 23 -71 23q-43 0 -77 -22q-33 -21 -57 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B6",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CF",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CE",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CD",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CC",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CB",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CA",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C9",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C8",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C7",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C6",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C5",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C4",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C3",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C2",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C1",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C0",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BF",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BE",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BD",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BC",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BB",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BA",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B9",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B7",
    horizAdvX: 568,
    d: "M263 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM216 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 568,
    d: "M483 487h-162v-487h-74v487h-162v70h398v-70zM483 607h-398v60h398v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1020,
    d: "M160 0h-74v695l466 -529v501h74v-697l-466 529v-499zM845 667q61 0 103 -42t42 -103t-42 -103t-103 -42t-103 42t-42 103t42 103t103 42zM845 432q36 0 60.5 26.5t24.5 63.5t-24.5 63.5t-60.5 26.5q-35 0 -60 -26.5t-25 -63.5t25 -63.5t60 -26.5zM720 227v70h250v-70 h-250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2117",
    unicode: "\u2117",
    horizAdvX: 740,
    d: "M263 519h74q80 0 110 -31q28 -28 28 -77t-28 -77q-31 -31 -99 -31h-31v-158h-54v374zM317 471v-120h22q47 0 65 17q17 15 17 44q0 26 -13 40q-17 19 -71 19h-20zM715 332q0 -138 -94 -238q-101 -107 -251 -107t-251 107q-94 100 -94 238q0 137 94 237q101 107 251 107 t251 -107q94 -100 94 -237zM370 620q-54 0 -109 -22t-94 -60q-41 -40 -63.5 -95t-22.5 -111q0 -57 22.5 -112t63.5 -95q39 -38 94 -60t109 -22t109 22t94 60q41 40 63.5 95t22.5 112q0 56 -22.5 111t-63.5 95q-39 38 -94 60t-109 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 722,
    d: "M234 621h-90v-334h-50v334h-90v46h230v-46zM316 287h-46l65 404l143 -315l147 315l61 -404h-46l-35 257l-127 -276l-125 276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 524,
    d: "M83 604l17 69q128 -12 219 -77q35 -25 67.5 -62.5t50.5 -71.5q45 -87 45 -213q0 -101 -41 -165q-61 -96 -179 -96q-98 0 -159 64.5t-61 159.5q0 96 59 160.5t155 64.5q85 0 133 -48h2q-31 98 -124 157q-78 50 -184 58zM408 218q0 65 -39 110t-104 45q-66 0 -107.5 -46 t-41.5 -117q0 -74 44 -116t102 -42q64 0 105 48.5t41 117.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 698,
    d: "M36 684v66h626v-66h-78v-868h78v-66h-234v66h82v868h-322v-868h81v-66h-233v66h78v868h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 686,
    d: "M32 750h574v-215h-74v149h-402l238 -413l-242 -455h414v147h74v-213h-582v46l252 476l-252 432v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    d: "M33 300v66h434v-66h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 592,
    d: "M0 -170l514 929l58 -30l-514 -927z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 200,
    d: "M36 340q0 26 19 45t45 19t45 -19t19 -45t-19 -45t-45 -19t-45 19t-19 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 668,
    d: "M409 827h259v-66h-199l-215 -761h-89l-82 300h-83v66h141l70 -268h2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 668,
    d: "M336 292q-26 -42 -68.5 -73.5t-96.5 -31.5q-67 0 -109.5 43t-42.5 111q0 66 42.5 109t109.5 43q51 0 93 -30.5t69 -74.5q26 42 68 73.5t98 31.5q66 0 108 -43t42 -111q0 -67 -42 -109.5t-108 -42.5q-55 0 -97 31.5t-66 73.5zM489 429q-37 0 -68 -27.5t-51 -61.5 q20 -38 53.5 -63.5t66.5 -25.5q35 0 60 24.5t25 64.5q0 37 -24 63t-62 26zM179 251q38 0 69 27.5t50 61.5q-19 37 -51.5 63t-68.5 26q-38 0 -61.5 -26t-23.5 -64q0 -42 26.5 -65t59.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    d: "M404 739l-16 -64q-21 11 -47 11q-27 0 -40 -15q-14 -15 -14 -87v-668q0 -32 -0.5 -47.5t-7 -39.5t-19.5 -40q-33 -39 -97 -39q-34 0 -67 11l16 64q21 -11 47 -11q27 0 40 15q14 15 14 87v668q0 32 0.5 47.5t7 39.5t19.5 40q33 39 97 39q34 0 67 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    d: "M446 488l44 -26q-19 -44 -50 -73q-39 -39 -96 -39q-34 0 -108 34q-69 32 -95 32q-29 0 -52 -20q-19 -16 -35 -52l-44 26q23 49 48 78q34 38 87 38q42 0 113 -34q69 -32 95 -32q37 0 61 24q19 17 32 44zM446 322l44 -26q-19 -44 -50 -73q-39 -39 -96 -39q-34 0 -108 34 q-69 32 -95 32q-29 0 -52 -20q-19 -16 -35 -52l-44 26q23 49 48 78q34 38 87 38q42 0 113 -34q69 -32 95 -32q37 0 61 24q19 17 32 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    d: "M33 384v66h240l55 114h59l-54 -114h134v-66h-166l-42 -88h208v-66h-240l-54 -114h-60l55 114h-135v66h166l43 88h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    d: "M110 377l357 -159v-68l-434 196v62l434 196v-68zM467 55h-434v66h434v-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    d: "M390 377l-357 159v68l434 -196v-62l-434 -196v68zM467 55h-434v66h434v-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotmath",
    unicode: "\u22C5",
    horizAdvX: 200,
    d: "M36 340q0 26 19 45t45 19t45 -19t19 -45t-19 -45t-45 -19t-45 19t-19 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 680,
    d: "M74 334l260 360l260 -360l-260 -360zM510 334l-176 243l-176 -243l176 -243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "openbullet",
    unicode: "\u25E6",
    horizAdvX: 493,
    d: "M108 531q0 59 39.5 98.5t98.5 39.5t98.5 -39.5t39.5 -98.5t-39.5 -98.5t-98.5 -39.5t-98.5 39.5t-39.5 98.5zM158 531q0 -43 27.5 -67.5t60.5 -24.5t60.5 24.5t27.5 67.5t-27.5 67.5t-60.5 24.5t-60.5 -24.5t-27.5 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF400",
    unicode: "\uF400",
    horizAdvX: 2,
    d: "M-186 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF401",
    unicode: "\uF401",
    horizAdvX: 2,
    d: "M-236 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF406",
    unicode: "\uF406",
    d: "M339 841h66q-7 -39 -31 -67q-46 -53 -124 -53t-124 53q-24 28 -31 67h66q7 -22 25 -36q26 -20 64 -20t64 20q18 14 25 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF407",
    unicode: "\uF407",
    d: "M264 -52l70 -30l-104 -128l-50 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF408",
    unicode: "\uF408",
    d: "M250 797l-88 -76l-52 41l140 119l140 -119l-52 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF409",
    unicode: "\uF409",
    d: "M168 -210l56 160l64 -24l-70 -156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40A",
    unicode: "\uF40A",
    d: "M190 520l52 160l64 -24l-70 -156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40B",
    unicode: "\uF40B",
    d: "M195 784q0 24 15.5 39.5t39.5 15.5t39.5 -15.5t15.5 -39.5t-15.5 -39.5t-39.5 -15.5t-39.5 15.5t-15.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40C",
    unicode: "\uF40C",
    d: "M162 818q0 36 26 62t62 26t62 -26t26 -62t-26 -62t-62 -26t-62 26t-26 62zM208 819q0 -17 13 -29.5t29 -12.5t29 12.5t13 29.5t-13 29.5t-29 12.5t-29 -12.5t-13 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40D",
    unicode: "\uF40D",
    d: "M362 842l43 -35q-9 -24 -26 -41q-30 -31 -70 -31q-23 0 -67 22q-42 20 -56 20q-17 0 -30 -13q-13 -15 -17 -31l-44 36q10 26 30 45q27 27 63 27q26 0 68 -21q40 -21 56 -21q18 0 32 14q12 12 18 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40E",
    unicode: "\uF40E",
    d: "M366 -117l-8 -59q-28 -14 -59 -14q-39 0 -68 23.5t-29 63.5q0 34 24 64q18 23 48 39h62q-32 -21 -47 -39q-23 -28 -23 -51q0 -40 52 -40q26 0 48 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4C6",
    unicode: "\uF4C6",
    horizAdvX: 590,
    d: "M430 667h74v-753q0 -79 -34 -113q-31 -31 -87 -31q-32 0 -55 9v72q19 -9 42 -9q30 0 44 13q16 15 16 57v374q-93 -7 -138 -7q-119 0 -165 36q-61 47 -61 155v197h74v-187q0 -81 40 -110q28 -21 116 -21q59 0 134 7v311z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4C7",
    unicode: "\uF4C7",
    horizAdvX: 430,
    d: "M290 415h72v-487q0 -28 -1 -43.5t-8.5 -39t-22.5 -40.5q-31 -35 -91 -35q-27 0 -51 9v70q25 -9 47 -9q32 0 46 22q9 15 9 60v241q-58 -9 -98 -9q-68 0 -101 30q-35 31 -35 102v129h72v-119q0 -34 9 -49q14 -27 63 -27q44 0 90 9v186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4CC",
    unicode: "\uF4CC",
    horizAdvX: 568,
    d: "M8 667h90l208 -393l174 393h80l-301 -667h-80l85 186zM366 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4CD",
    unicode: "\uF4CD",
    horizAdvX: 460,
    d: "M67 -230l132 269l-191 376h82l147 -297l135 297h80l-305 -645h-80zM292 666l74 -34l-134 -135l-45 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar.fitted",
    unicode: "\uF5F5",
    horizAdvX: 442,
    d: "M402 574l-59 -39q-15 31 -38 50q-19 17 -43 21v-222q79 -31 117 -70q47 -48 47 -121q0 -72 -44 -130.5t-120 -70.5v-93h-60v89q-75 3 -128 54q-46 46 -62 118l72 20q8 -52 40 -85q34 -35 78 -37v274q-72 29 -110 65q-46 43 -46 109q0 70 45 117t111 53v87h60v-87 q42 -4 76 -28q40 -28 64 -74zM262 304v-242q40 11 64 48t24 80q0 47 -32 79q-21 21 -56 35zM202 411v195q-39 -6 -60.5 -34t-21.5 -65q0 -35 25 -60q22 -22 57 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro.fitted",
    unicode: "\uF5F6",
    horizAdvX: 587,
    d: "M554 622l-33 -67q-63 53 -151 53q-39 0 -72.5 -12.5t-54.5 -30.5t-37.5 -42t-25 -43.5t-13.5 -39.5h319l-26 -66h-305q-6 -39 -1 -78h281l-26 -66h-244q15 -76 70 -124t137 -48q100 0 182 77v-92q-82 -55 -186 -55q-122 0 -195 69.5t-88 172.5h-67l26 66h34q-5 41 1 78 h-61l26 66h43q21 100 96 169t192 69q99 0 179 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent.fitted",
    unicode: "\uF5F7",
    horizAdvX: 383,
    d: "M258 655v-97q58 -7 105 -39v-86q-45 54 -105 61v-306q62 7 108 63v-86q-48 -35 -108 -42v-109h-60v111q-76 11 -127 61q-59 57 -59 153t62 158q49 49 124 59v99h60zM198 189v302q-40 -5 -69 -34q-43 -43 -43 -117q0 -71 44 -115q27 -27 68 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling.fitted",
    unicode: "\uF5F8",
    horizAdvX: 526,
    d: "M468 458h-73v10q0 70 -36 106q-32 32 -85 32q-52 0 -83 -31q-37 -35 -37 -88q0 -12 2.5 -25t5 -22.5t9 -24.5t10.5 -22.5t13 -25.5l13 -26l14 -28h126v-56h-101q11 -29 11 -61q0 -48 -29 -94l59 -22q54 -21 70 -21q30 0 53 22q20 20 31 47l61 -36q-18 -42 -49 -68 q-41 -35 -89 -35q-40 0 -86 18l-39 15q-50 19 -75 19q-30 0 -53 -18q-22 -17 -30 -36l-57 39q24 36 47 55q36 30 82 30q28 42 28 86q0 30 -13 60h-112v56h86l-20 37q-44 81 -44 139q0 81 53 134t144 53q83 0 133 -50q60 -58 60 -159v-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen.fitted",
    unicode: "\uF5F9",
    horizAdvX: 546,
    d: "M507 384h-141l-51 -88h192v-56h-198v-240h-74v240h-195v56h189l-51 88h-138v56h106l-131 227h87l170 -298l172 298h87l-133 -227h109v-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin.fitted",
    unicode: "\uF5FA",
    horizAdvX: 481,
    d: "M415 355h-108l-61 -329q-6 -35 -11.5 -55.5t-18.5 -47.5t-32 -46q-48 -47 -139 -47q-18 0 -42 4l14 64q14 -2 25 -2q59 0 89 29q31 31 48 128l55 302h-72l9 60h74l33 179q14 78 49 113q33 33 92 33q34 0 64 -10l-13 -67q-26 11 -46 11q-26 0 -44 -16q-20 -20 -32 -84 l-30 -159h106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4.fitted",
    unicode: "\uF5FB",
    horizAdvX: 477,
    d: "M112 535l-59 39q35 45 79 71q55 33 127 33q70 0 112 -36q42 -35 42 -89q0 -62 -49 -113h93v-56h-138l-89 -88h227v-56h-278q-45 -42 -45 -100q0 -34 25 -57q27 -25 74 -25q56 0 97 38q30 29 49 74l68 -30q-20 -55 -59 -92q-61 -60 -159 -60q-74 0 -118 33q-53 42 -53 114 q0 57 39 105h-77v56h122l89 88h-211v56h262q57 50 57 95q0 30 -22 50q-24 23 -71 23q-43 0 -77 -22q-33 -21 -57 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6.fitted",
    unicode: "\uF5FC",
    horizAdvX: 453,
    d: "M215 667q121 0 177 -56q52 -52 52 -134q0 -79 -50 -127q-57 -56 -161 -56h-65v-88h164v-56h-164v-150h-74v150h-76v56h76v88h-76v66h76v307h121zM168 597v-237h61q75 0 112 39q29 32 29 84q0 48 -28 76q-37 38 -119 38h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8.fitted",
    unicode: "\uF5FD",
    horizAdvX: 408,
    d: "M403 487h-162v-487h-74v487h-162v70h398v-70zM403 607h-398v60h398v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF639",
    unicode: "\uF639",
    horizAdvX: 530,
    d: "M265 -12q-102 0 -171 100q-67 97 -67 245t67 245q69 100 171 100t171 -100q67 -97 67 -245t-67 -245q-69 -100 -171 -100zM265 610q-69 0 -115 -74q-49 -78 -49 -203t49 -203q46 -74 115 -74t115 74q49 78 49 203t-49 203q-46 74 -115 74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63A",
    unicode: "\uF63A",
    horizAdvX: 480,
    d: "M454 0h-431l243 281q62 73 78 97q37 53 37 102q0 57 -37 93.5t-96 36.5q-72 0 -111 -59q-21 -32 -22 -79h-74q4 85 50 138q59 68 158 68q89 0 147.5 -56.5t58.5 -142.5q0 -67 -53 -143q-27 -37 -91 -111l-139 -157h282v-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63B",
    unicode: "\uF63B",
    horizAdvX: 457,
    d: "M118 502h-74q3 53 31 98q50 78 155 78q89 0 138.5 -53t49.5 -127q0 -105 -86 -148q13 -5 25.5 -13.5t30.5 -26.5t29 -49.5t11 -71.5q0 -91 -58.5 -146t-146.5 -55q-59 0 -110 27.5t-76 87.5q-13 32 -15 70h74q5 -41 24 -67q34 -50 103 -50q55 0 93 39.5t38 95.5 q0 82 -66 112q-33 16 -76 14v66q43 -3 76 14q56 29 56 99q0 49 -28 81.5t-86 32.5q-56 0 -86 -38q-23 -30 -26 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63C",
    unicode: "\uF63C",
    horizAdvX: 520,
    d: "M417 704v-510h82v-68h-82v-126h-74v126h-342zM132 194h211v295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63D",
    unicode: "\uF63D",
    horizAdvX: 490,
    d: "M459 667v-68h-214l-43 -144q17 4 42 4q99 0 159.5 -66t60.5 -165q0 -108 -70.5 -174t-172.5 -66q-86 0 -149 52q-36 31 -58 68l59 42q15 -30 45 -54q49 -40 108 -40q70 0 117 50t47 121q0 72 -46.5 118t-117.5 46q-63 0 -129 -46l97 322h265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63E",
    unicode: "\uF63E",
    horizAdvX: 496,
    d: "M298 683l56 -42l-153 -213q29 9 59 9q95 0 155.5 -63t60.5 -157q0 -100 -64.5 -164.5t-164.5 -64.5q-74 0 -128.5 35.5t-78.5 86t-24 105.5q0 76 55 153zM246 56q68 0 112 45.5t44 113.5q0 67 -44.5 110.5t-112.5 43.5t-111.5 -44t-43.5 -110q0 -68 43.5 -113.5 t112.5 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63F",
    unicode: "\uF63F",
    horizAdvX: 528,
    d: "M22 23l379 576h-365v68h490l-446 -683z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF640",
    unicode: "\uF640",
    horizAdvX: 464,
    d: "M335 347q101 -45 101 -163q0 -83 -53.5 -139.5t-150.5 -56.5t-150.5 56.5t-53.5 139.5q0 118 101 163q-81 47 -81 146q0 76 49 130.5t135 54.5t135 -54.5t49 -130.5q0 -99 -81 -146zM232 377q49 0 81.5 33t32.5 82q0 53 -33.5 85.5t-80.5 32.5t-80.5 -32.5t-33.5 -85.5 q0 -49 32.5 -82t81.5 -33zM232 56q58 0 94 36.5t36 93.5q0 56 -36.5 91.5t-93.5 35.5t-93.5 -35.5t-36.5 -91.5q0 -57 36 -93.5t94 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF641",
    unicode: "\uF641",
    horizAdvX: 496,
    d: "M198 -16l-56 41l153 213q-29 -9 -59 -9q-95 0 -155.5 63t-60.5 157q0 100 64.5 164.5t164.5 64.5q74 0 128.5 -35.5t78.5 -86t24 -105.5q0 -77 -55 -153zM250 610q-68 0 -112 -45.5t-44 -113.5q0 -67 44.5 -110.5t112.5 -43.5t111.5 44t43.5 110q0 68 -43.5 113.5 t-112.5 45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BA",
    unicode: "\uF6BA",
    horizAdvX: 320,
    d: "M50 302v74h220v-74h-220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BB",
    unicode: "\uF6BB",
    horizAdvX: 580,
    d: "M70 307v64h440v-64h-440z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BC",
    unicode: "\uF6BC",
    horizAdvX: 800,
    d: "M70 307v64h660v-64h-660z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6C3",
    unicode: "\uF6C3",
    d: "M170 -210l56 160l64 -24l-70 -156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6C9",
    unicode: "\uF6C9",
    d: "M332 882l70 -45l-153 -117l-43 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CA",
    unicode: "\uF6CA",
    d: "M250 805l88 76l52 -41l-140 -119l-140 119l52 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CB",
    unicode: "\uF6CB",
    d: "M104 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36zM294 784q0 21 15 36t36 15t36 -15t15 -36t-15 -36t-36 -15t-36 15t-15 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CE",
    unicode: "\uF6CE",
    d: "M251 720l-153 117l70 45l126 -130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CF",
    unicode: "\uF6CF",
    d: "M254 882l70 -40l-147 -122l-43 26zM404 882l70 -40l-147 -122l-43 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D0",
    unicode: "\uF6D0",
    d: "M90 733v64h320v-64h-320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D1",
    unicode: "\uF6D1",
    d: "M95 818l70 23q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l70 -23q-4 -11 -11.5 -23t-24.5 -31t-48 -31t-71 -12t-71 12t-48 31t-24.5 31t-11.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D4",
    unicode: "\uF6D4",
    d: "M105 594l60 23q18 -60 85 -60t85 60l60 -23q-16 -45 -54.5 -71t-90.5 -26t-90.5 26t-54.5 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6DC",
    unicode: "\uF6DC",
    horizAdvX: 229,
    d: "M114 0v597h-112l39 70h147v-667h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6DE",
    unicode: "\uF6DE",
    horizAdvX: 600,
    d: "M52 181v64h495v-64h-495z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nbspace",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphenminus",
    horizAdvX: 320,
    d: "M50 176v74h220v-74h-220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi1",
    horizAdvX: 208,
    d: "M68 415h72v-415h-72v415z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "S",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "O",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "G",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "Q",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04DD",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04C2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0497",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0459",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0436",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ",",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "9",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "8",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "5",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "4",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "3",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "2",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "1",
    k: 225
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "1",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "5",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "1",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "1",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "1",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ":",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "5",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "1",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "5",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "1",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2018",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "*",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "J",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "J",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BC",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BA",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2014",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2013",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2012",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2011",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2010",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "z",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "S",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "-",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u2122",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "v",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "p",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "J",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2122",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Q",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "*",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "\u2122",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Y",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "W",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Y",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "J",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "v",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "J",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "q",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "m",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "Q",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "x",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "v",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "p",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "m",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "w",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2039",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "m",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "M",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "Q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "J",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "J",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "J",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "x",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "v",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "X",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "Q",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "J",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "T",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "J",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "Y",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "T",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "J",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u2026",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "v",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "f",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "Q",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "J",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "v",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "b",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "Q",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "J",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "hyphenminus",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BC",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BB",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BA",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2014",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2013",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2012",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2011",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2010",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "-",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u2026",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10017.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04D2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04D0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04B8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04B6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10071.var.accented",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10097.var.accented",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10095.var.accented",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10049.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04F5",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04DD",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C2",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B9",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B7",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B3",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u049D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u049B",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0497",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0473",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0472",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u045E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0451",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044F",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044D",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0447",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0445",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0442",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u043C",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0436",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0434",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0431",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042A",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0409",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0404",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ":",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ".",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u201C",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2018",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u041C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0406",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u0407",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10032.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04EA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04E8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04E6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04D8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u041E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B6",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0414",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    g2: "afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F0",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04EE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04AE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0423",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u040E",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F4",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0427",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0414",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10071.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10085.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10070.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10037.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0493",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0491",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0457",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0453",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0451",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0443",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0435",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0433",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0423",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0422",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u041E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u040E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10096.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10093.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10080.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10074.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0472",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0449",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0448",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0446",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0441",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0439",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0438",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u042A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0412",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0404",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10097.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10095.var.accented",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10074.var.accented",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2018",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04EB",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E9",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E7",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04DD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04AB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04AA",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04A3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u049D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u049B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0497",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0473",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0472",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u045F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0458",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0456",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0445",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0444",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043F",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0439",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0436",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0434",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0421",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u041C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0414",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ":",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040F",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    g2: "hyphenminus",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u201D",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u201C",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2018",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10037.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10032.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10017.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04EE",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04EA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04E8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04E6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04DE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04AE",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0498",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0423",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0417",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040E",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0409",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10049.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10047.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0414",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0404",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0402",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10071.var.accented",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10097.var.accented",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10095.var.accented",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10049.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04F5",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04DD",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C2",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B9",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B7",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B3",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u049D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u049B",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0497",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0473",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0472",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u045E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0451",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044F",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044D",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0447",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0445",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0442",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043C",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0436",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0434",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0431",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042A",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0409",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0404",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ":",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ".",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "afii10047.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "afii10037.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04F2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04F0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04EE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04DE",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04AE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0498",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u042D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0423",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u041B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0417",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u040E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0409",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10096.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10093.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10047.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04AA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0472",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0449",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0444",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0427",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0421",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u2122",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u201C",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0402",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0418",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0419",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10071.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10085.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10070.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10037.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0493",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0491",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0457",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0453",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0451",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0443",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0435",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0433",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0423",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0422",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u041E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u040E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10096.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10093.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10080.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10074.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0472",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0449",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0448",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0446",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0441",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0439",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0438",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u042A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0412",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0404",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2019",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2122",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10095.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10085.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04EF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04DF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0499",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u045E",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u044D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0443",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0437",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0442",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u042A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041D",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u201C",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u2018",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041F",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10071.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10095.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10085.var.accented",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10070.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10065.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10017.var.accented",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F3",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F1",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04EF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D0",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04AF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0499",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0498",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u045E",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u045B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0459",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0452",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0451",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0443",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0440",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0437",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0435",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0422",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041B",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u040B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0402",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ",",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10097.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2122",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2026",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0409",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u041C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10071.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10096.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10093.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10080.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10074.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10070.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10065.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10047.var.accented",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10037.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10032.var.accented",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10017.var.accented",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F0",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E8",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DF",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D8",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D3",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D2",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D1",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04A3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0499",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0498",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0493",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0491",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0459",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0454",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0453",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0452",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0451",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0449",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0448",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0446",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0441",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0440",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0439",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0438",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0435",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0433",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0432",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042D",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0423",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0422",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0421",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041E",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0417",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040E",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ";",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ":",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ",",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10097.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10095.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2026",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u201C",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DD",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u049D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u049B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0497",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0473",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0472",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0458",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0457",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0456",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0444",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0409",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0402",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10097.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10095.var.accented",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10074.var.accented",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2018",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04EB",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E9",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E7",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04DD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04AB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04AA",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04A3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u049D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u049B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0497",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0473",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0472",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u045F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0458",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0456",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0445",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0444",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043F",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0439",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0436",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0434",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0421",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u041C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0414",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: ":",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10047.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10017.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04D2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04D0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u041B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0409",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u041E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u041B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0409",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0427",
    u2: "\u2122",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0428",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2122",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u201C",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0414",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042B",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0422",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040B",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0402",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0414",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0409",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u201C",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2018",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u201C",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04DC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04C1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0496",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u2026",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ":",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ".",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "afii10037.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F2",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F0",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04EE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04AE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0459",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u043B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0423",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0422",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u041B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u040E",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0409",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u043B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0434",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "hyphenminus",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BC",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BB",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BA",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2014",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2013",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2012",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2011",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2010",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "-",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    g2: "afii10037.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u201D",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u2019",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F2",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F0",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04EE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04AE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0423",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u040E",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u201C",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u2018",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    g2: "hyphenminus",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BC",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BB",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BA",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2014",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2013",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2012",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2011",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2010",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "-",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    g2: "afii10080.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04EB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04E9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04E7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u043E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10085.var.accented",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10070.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10065.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F3",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F1",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04DF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0499",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u045E",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0451",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0443",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0437",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0435",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0409",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ";",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ",",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2026",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044A",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0442",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ":",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ".",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u044A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: ".",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10070.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04DF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0499",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0451",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0437",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0435",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u043B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u041B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0409",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2122",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "hyphenminus",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BC",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BB",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BA",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u201D",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2019",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2014",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2013",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2012",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2011",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2010",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u043B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u041B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0409",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "-",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u201C",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2018",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04DD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04C2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0497",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0422",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u040B",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0402",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    g2: "afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F0",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04EE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04AE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0423",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u040E",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10071.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10070.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10065.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04D9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04D7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04D3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04D1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0451",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0435",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0430",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0422",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u040B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0402",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u2026",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0434",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: ":",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: ".",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    g2: "afii10080.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04EB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04E9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04E7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u043E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u0457",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10085.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04EF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04AF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u045E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0443",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10085.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04EF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0443",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u201C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u2018",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04DD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04C2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0497",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0436",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u043B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0434",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u044A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: ".",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10037.var.accented",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04F2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04F0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04EE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04D2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04D0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04AE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0423",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u040E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u201C",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2018",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ";",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ",",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: "\u2026",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ":",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ".",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0475",
    u2: ",",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0475",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0475",
    u2: ".",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10096.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10093.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10085.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10080.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10074.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10070.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10065.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10047.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10032.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10017.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F1",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EF",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DF",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D1",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AF",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04A3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0499",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045F",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0459",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044C",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044B",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0449",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0448",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0446",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0444",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0443",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0441",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0440",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043F",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0439",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0438",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0437",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0435",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0432",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0430",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0410",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10071.var.accented",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10097.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10095.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10049.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2026",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F5",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DD",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C2",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B9",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B7",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B3",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u049D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u049B",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0497",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0493",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0491",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0473",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0472",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0456",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0454",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0453",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0451",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044F",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044D",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0447",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0445",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0442",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0436",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0434",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0433",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0431",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0414",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0409",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0404",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ":",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ".",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10071.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10070.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10065.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04D9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04D7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04D3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04D1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0451",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0435",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0430",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u2026",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: ":",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: ".",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10071.var.accented",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10097.var.accented",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10095.var.accented",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10049.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04F5",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04DD",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C2",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B9",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B7",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B3",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u049D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u049B",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0497",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0473",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0472",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u045E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0451",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044F",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044D",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0447",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0445",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0442",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u043C",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0436",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0434",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0431",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042A",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0409",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0404",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: ":",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: ".",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u2026",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: ":",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: ".",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10096.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10093.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10047.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04AA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0472",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0449",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0444",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0427",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0421",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u2122",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u201C",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0402",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10071.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10085.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10070.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10037.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0493",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0491",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0457",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0453",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0451",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0443",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0435",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0433",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0423",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0422",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u041E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u040E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10096.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10093.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10080.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10074.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0472",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0449",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0448",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0446",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0441",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0439",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0438",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u042A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0412",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0404",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u043B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0434",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10071.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10085.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10070.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10037.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0493",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0491",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0457",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0453",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0451",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0443",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0435",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0433",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0423",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0422",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u041E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u040E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10096.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10093.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10080.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10074.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0472",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0449",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0448",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0446",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0441",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0439",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0438",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u042A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0412",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0404",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u043B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0434",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u041C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    g2: "afii10080.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u04EB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u04E9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u04E7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u043E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "hyphenminus",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10032.var.accented",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2014",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2013",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2012",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2011",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2010",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04EA",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04D8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u041E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0404",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ";",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "-",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10097.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10095.var.accented",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10074.var.accented",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2026",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2018",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04EB",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E9",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E7",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04DD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AA",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04A3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u049D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u049B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0497",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0473",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0472",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u045F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0458",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0456",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0445",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0444",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043F",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0439",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0436",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0434",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0421",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u041C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0414",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ":",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ".",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0455",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u044A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: ".",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10085.var.accented",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F3",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F1",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EF",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AF",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u045E",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0443",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u041E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u041B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0409",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04DF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0499",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0437",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u2122",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B8",
    u2: "\u2122",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10096.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10093.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10047.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04AA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0472",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0449",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0444",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0427",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0421",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10071.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10085.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10070.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10037.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0493",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0491",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0457",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0453",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0451",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0443",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0435",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0433",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0423",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0422",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u041E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u040E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10096.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10093.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10080.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10074.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0472",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0449",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0448",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0446",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0441",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0439",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0438",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u042A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0412",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0404",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u043B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0434",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C7",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10085.var.accented",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04EF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u045E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0443",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "hyphenminus",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u201D",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u201C",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2018",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u042A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0424",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "*",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10085.var.accented",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04EF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u045E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0443",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "hyphenminus",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u201D",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u201C",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2018",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u042A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0424",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "*",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u201C",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u2018",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10096.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10093.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10047.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04AA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0472",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0449",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0444",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0427",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0421",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u2122",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u201C",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0402",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E2",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E4",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u201C",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u2018",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u201C",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u2018",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u201C",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u2018",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10097.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10095.var.accented",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10074.var.accented",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2018",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04EB",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E9",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E7",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04DD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04AB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04AA",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04A3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u049D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u049B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0497",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0473",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0472",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u045F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0458",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0456",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0445",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0444",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u043F",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u043D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0439",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0436",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0434",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0421",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u041C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0414",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: ":",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u044A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: ".",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10097.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10095.var.accented",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10074.var.accented",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2018",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04EB",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E9",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E7",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04DD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04AB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04AA",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04A3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u049D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u049B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0497",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0473",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0472",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u045F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0458",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0456",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0445",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0444",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u043F",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u043D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0439",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0436",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0434",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0421",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u041C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0414",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: ":",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u044A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: ".",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10097.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10095.var.accented",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10074.var.accented",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2018",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04EB",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E9",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E7",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04DD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04AB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04AA",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04A3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u049D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u049B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0497",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0473",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0472",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u045F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0458",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0456",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0445",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0444",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u043F",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u043D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0439",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0436",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0434",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0421",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u041C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0414",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: ":",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u044A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: ".",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F4",
    u2: "\u2122",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F8",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04DD",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04C2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0497",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0459",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0436",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04DD",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04C2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0497",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0459",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0436",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04DD",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04C2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0497",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0459",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0436",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04DD",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04C2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0497",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0459",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0436",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04DD",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04C2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0497",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0459",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0436",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10071.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10096.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10093.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10085.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10074.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10070.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10065.var.accented",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10047.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10017.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D3",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D1",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D0",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04C8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04A3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0493",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0491",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0457",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0456",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0453",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0451",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0449",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0448",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0446",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0439",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0438",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0435",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0433",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0432",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0430",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u042D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0410",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "y",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "w",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "r",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "o",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "g",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "e",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "d",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "c",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "a",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "S",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "A",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ",",
    k: 167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10080.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EB",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0473",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0459",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0444",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0441",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0434",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0424",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0414",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u040E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0409",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "J",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ".",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "afii10017.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u04D2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u04D0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0422",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0410",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u040B",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0402",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "c",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "Y",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "W",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "V",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "T",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "A",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "J",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10085.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u045E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0443",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Y",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "S",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F4",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B8",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B6",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0427",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "Y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10085.var.accented",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04EF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u045E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0443",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "hyphenminus",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u201D",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u201C",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2018",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u042A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0424",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "*",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10026.var.accented",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u201C",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u2018",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10097.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10095.var.accented",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10074.var.accented",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2018",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04EB",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E9",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E7",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04DD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04AB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04AA",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04A3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u049D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u049B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0497",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0473",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0472",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u045F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0458",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0456",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0445",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0444",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u043F",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u043D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0439",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0436",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0434",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0421",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u041C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0414",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: ":",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10045.var.accented",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u201C",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2018",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u201C",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10049.var.accented",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u044A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: ".",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0422",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u040B",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0402",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    g2: "afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F0",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04EE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04AE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0423",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u040E",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10071.var.accented",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10096.var.accented",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10093.var.accented",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10085.var.accented",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10070.var.accented",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10065.var.accented",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10047.var.accented",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10032.var.accented",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10017.var.accented",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F9",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04EF",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04EA",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E6",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DF",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DE",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D3",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D2",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D1",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D0",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04AF",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0499",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0498",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0493",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0491",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045F",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045A",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0459",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0458",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0457",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0456",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0454",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0453",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0451",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044E",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044B",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0449",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0448",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0446",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0443",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0440",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043B",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0437",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0435",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0433",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0432",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0430",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u042D",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u041E",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u041B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0417",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0410",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0409",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0404",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ";",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ",",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10097.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10095.var.accented",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10080.var.accented",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10074.var.accented",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u2026",
    k: 190
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04EB",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E9",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E7",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DD",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04AB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04AA",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04A3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u049D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u049B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0497",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0473",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0472",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045C",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044C",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0447",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0445",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0444",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0442",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0441",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043F",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043E",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0439",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0438",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0436",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0434",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0431",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0421",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0414",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ":",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ".",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    g2: "afii10095.var.accented",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: "\u04DF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: "\u0499",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: "\u044D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: "\u0437",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: ".",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04DD",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04C2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0497",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0459",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0436",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04DD",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04C2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0497",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0459",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0436",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04DD",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04C2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0497",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0459",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0436",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    g2: "afii10017.var.accented",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04D2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04D0",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0422",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0410",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u040B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0402",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "T",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04DD",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04C2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0497",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u045E",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0459",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0436",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0434",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0414",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "S",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "T",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "W",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "w",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "y",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "quoteright,quotedblright",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "Z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "Y",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "quoteright,quotedblright",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "G",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "O",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "S",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "Y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "w",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "y",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "U",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "e",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "g",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "s",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "t",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "u",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "G",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "O",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "w",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "y",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "T",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "Y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "quoteright,quotedblright",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "Y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "a",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "g",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "T",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "Y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "G",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "O",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "S",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "T",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "Y",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "w",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "y",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "z",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "d",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "e",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "g",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "o",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "s",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "comma,period",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "colon,semicolon",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "h,n",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "r",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U",
    g2: "Z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "e",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "o",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "h,n",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "r",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "w",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "z",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "d",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "e",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "o",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "s",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "u",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "comma,period",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "colon,semicolon",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "h,n",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "r",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "C",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "G",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "O",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "S",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "T",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "V",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "w",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "y",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "z",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "a",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "c",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "d",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "e",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "g",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "o",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "s",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "t",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "u",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "A",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "comma,period",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "colon,semicolon",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "h,n",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "r",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "S",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "a",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "d",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "e",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "s",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "u",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d",
    g2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "C",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "G",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "O",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "w",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quoteright,quotedblright",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "t",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "W",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "Y",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "o",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "Y",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "C",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "O",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "Y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "w",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "y",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "z",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "d",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "e",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "o",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "t",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "comma,period",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "Y",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "C",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "T",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "Y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "w",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "y",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "t",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "colon,semicolon",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "T",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "comma,period",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "comma,period",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "a",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "d",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "s",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "A",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "V",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "W",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "Y",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "Y",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10058,afii10029",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10077,afii10106",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10058,afii10029",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10077,afii10106",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "quoteright,quotedblright",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "comma,period",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "colon,semicolon",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10058,afii10029",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10077,afii10106",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10051,afii10060,afii10036",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10082,afii10105",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10099,afii10108",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023,afii10022,uni04D6,afii10022.var.accented,afii10023.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10082,afii10105",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "quoteright,quotedblright",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "quoteright,quotedblright",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "comma,period",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "colon,semicolon",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10058,afii10029",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10077,afii10106",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10082,afii10105",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10099,afii10108",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10058,afii10029",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10051,afii10060,afii10036",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10066,afii10080,afii10082,afii10086,afii10095,afii10096,afii10846,uni04E7,uni04E9,uni04EB,afii10080.var.accented,afii10095.var.accented,afii10096.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10066,afii10080,afii10082,afii10086,afii10095,afii10096,afii10846,uni04E7,uni04E9,uni04EB,afii10080.var.accented,afii10095.var.accented,afii10096.var.accented",
    g2: "afii10058,afii10029",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10066,afii10080,afii10082,afii10086,afii10095,afii10096,afii10846,uni04E7,uni04E9,uni04EB,afii10080.var.accented,afii10095.var.accented,afii10096.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10051,afii10060,afii10036",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "comma,period",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "colon,semicolon",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10058,afii10029",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10077,afii10106",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10051,afii10060,afii10036",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10051,afii10060,afii10036",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074,afii10075,afii10079,afii10081,afii10089,afii10090,afii10093,afii10097,afii10193,uni04A3,uni04B7,uni04B9,uni04BB,uni04C8,uni04E3,uni04E5,uni04F5,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10097.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074,afii10075,afii10079,afii10081,afii10089,afii10090,afii10093,afii10097,afii10193,uni04A3,uni04B7,uni04B9,uni04BB,uni04C8,uni04E3,uni04E5,uni04F5,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10097.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10051,afii10060,afii10036",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "quoteright,quotedblright",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "comma,period",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "colon,semicolon",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10058,afii10029",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10077,afii10106",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10051,afii10060,afii10036",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10051,afii10060,afii10036",
    k: 41
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturaCyrillicBook);
export default __webpack_public_path__ + "static/media/FuturaCyrillicBook.b823478fdda6f1595bd48103702f9ea3.svg";
export { ForwardRef as ReactComponent };